// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../../../node_modules/@radix-ui/colors/black-alpha.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../../../node_modules/@radix-ui/colors/green.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../../../node_modules/@radix-ui/colors/mauve.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../../../node_modules/@radix-ui/colors/violet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button,
fieldset,
input {
  all: unset;
}

.headerInfoContrato {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: end;
  width: 420px;
}


.headerInfoContrato .class1 {
  border-radius: 12px;
  padding: 12px;
  width: 160px;
  height: 30px;
  justify-content: center;
  display: flex;
  align-items: center;
  box-shadow: 9px 10px 26px -6px rgba(0, 0, 0, 0.45);
}

.headerInfoContrato .class2 {
  border-radius: 12px;
  padding: 12px;
  width: 250px;
  height: 30px;
  justify-content: center;
  display: flex;
  align-items: center;
  box-shadow: 9px 10px 26px -6px rgba(0, 0, 0, 0.45);
}



.labelRowSelect {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 24px;
}

.countersColors {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-self: center;
  justify-content: flex-end;

}

.countersColors>div {
  padding: 5px;
  width: 30px;
  height: 30px;
  border: 1px solid black;
  border-radius: 4px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  font-weight: 700;
  color: black;

}

.countersColors>.red {
  background-color: #E02B28;
}

.countersColors>.yellow {
  background-color: #E0A019;
}

.countersColors>.green {
  background-color: #5DE02B;
}

.countersColors>.blue {
  background-color: #006699;
}

.countersColors>.trans {
  background-color: transparent;
}

.labelRowSelect .label_trafico {
  width: 30%;
  font-size: 15px;
}

.labelRowSelect .form-select {
  width: 30%;
}

.DialogOverlay {
  background-color: var(--black-a9);
  position: fixed;
  inset: 0;
  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 9999;
}

.DialogContent {
  background-color: white;
  border-radius: 6px;
  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 90vw;
  max-height: 100vh;
  padding: 25px;
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 9999;
  overflow-y: hidden;
  overflow-x: hidden;
}

.DialogContent:focus {
  outline: none;
}

.rowInfo {
  display: flex;
  justify-content: space-between;
  margin-top: 0px;
}

.DialogTitle {
  margin: 0;
  font-weight: 500;
  color: var(--mauve-12);
  font-size: 17px;
}

.DialogDescription {
  margin: 10px 0 20px;
  color: var(--mauve-11);
  font-size: 15px;
  line-height: 1.5;
}

.Button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 15px;
  font-size: 15px;
  line-height: 1;
  font-weight: 500;
  height: 35px;
}

.buttonSolicitudes {
  display: flex;
  flex-direction: row;
  gap: 12px;
  color: white;
  justify-content: end;
}

.buttonSolicitudes button {
  background-color: #006699;
  padding: 10px;
  border-radius: 24px;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.buttonSolicitudes button:hover {
  background-color: #0176b1;
}

.Button.blue {
  background-color: #006699;
  color: white;
}

.Button.violet {
  background-color: white;
  color: var(--violet-11);
  box-shadow: 0 2px 10px var(--black-a7);
}

.Button.blue:hover {
  background-color: #0176b1;
}

.Button.violet:hover {
  background-color: var(--mauve-3);
}

.Button.violet:focus {
  box-shadow: 0 0 0 2px black;
}

.Button.green {
  background-color: var(--green-4);
  color: var(--green-11);
}

.Button.green:hover {
  background-color: var(--green-5);
}

.Button.green:focus {
  box-shadow: 0 0 0 2px var(--green-7);
}

.IconButton {
  font-family: inherit;
  border-radius: 100%;
  height: 25px;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--violet-11);
  position: absolute;
  top: 10px;
  right: 10px;
}

.IconButton:hover {
  background-color: var(--violet-4);
}

.IconButton:focus {
  box-shadow: 0 0 0 2px var(--violet-7);
}

.Fieldset {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 15px;
}

.Fieldset.column {
  flex-direction: column;
  align-items: flex-start;
}

.Fieldset.column label {
  margin-bottom: -12px;
}

.FieldsetRow {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  width: 100%;
}

.contToltip {
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-bottom: 0px;

}

#observacionesTextReporteSeguimiento {
  width: 250px !important;
}



#unidadCarga,
#clientConsulta2,
#destAutorizado,
#clientConsulta1,
#clientConsulta3 {
  width: 192px;
}

#solicitante {
  width: 400px;
}

#catServicio {
  width: 293px;
  margin-bottom: 0;
}

#CatServicioFather>.contToltip {
  margin-bottom: 0px;
}


#causalCategoria,
#datosEntrega {
  width: 420px;
}

#observacionesServicio {
  width: 100%;
  text-align: center;
  justify-content: center;
  display: flex;
}

#observacionesServicio .InputTooltipWrapper {
  width: 79%;
}

.Label {
  font-size: 15px;
  color: black;
  font-weight: 700;
  margin-bottom: 0px;
  padding-left: 0px;
  align-self: center;
}

.LabelTracking {
  font-size: 12px;
  color: black;
  font-weight: 700;
  margin-bottom: 0px;
  padding-left: 0px;
  align-self: center;
}

.InputTooltipWrapper {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 0px;
}

.reporteSeolicitud {
  display: flex;
  text-align: start;
  justify-content: start;
}

.reporteSeolicitudInputt {
  display: flex;
  text-align: start;
  justify-content: flex-start;
}

.reporteMonitoreoInputt {
  display: flex;
  text-align: start;
  justify-content: flex-start;
  transform: translateX(-4px);
}

.reporteMonitoreoInputt2 {
  display: flex;
  text-align: start;
  justify-content: flex-start;
  transform: translateX(-4px);
}


#fechaHoraCitaReport {
  width: 100px !important;

}

#guiaContenedorNro {
  width: 10px;
}

.InputTooltipWrapper label {
  margin-bottom: 0;
  justify-content: end;
  display: flex;
  margin-top: -3px;
}

.Input {
  width: 230px;
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: start;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  height: 20px;
  margin-bottom: 5px;
  border: 1px solid black;
}



.FechaProyecto {
  width: 230px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  height: 20px;
  margin-bottom: 5px;
  border: 1px solid black;
}



#placaTruck,
#placaRemolque {
  text-transform: uppercase;
}

.TextArea {
  width: 100%;
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  box-shadow: 0 0 0 1px black;
  height: 47px;
  border: none;
}

.TextArea1 {
  width: 83%;
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  box-shadow: 0 0 0 1px black;
  height: 60px;
  border: none;
}

.TextAreaMult {
  width: 100%;
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  box-shadow: 0 0 0 1px black;
  height: 190px;
  border: none;
}

.TextAreaReportSe {
  width: 290px;
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  box-shadow: 0 0 0 1px black;
  height: 70px;
  border: none;
}

.TextAreaReportSe2 {
  width: 401px;
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  box-shadow: 0 0 0 1px black;
  height: 70px;
  border: none;
}

/* Tabloa de reportes cambios  */
.tr-th-report td {
  height: 20px !important;
}

#tabla {
  max-height: 160px;
  overflow: auto;
}

.InputTime {
  border: 1px solid black;
  padding: 8px;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  background-color: #f9f9f9;
  width: 250px;
  height: 24px;
  box-sizing: border-box;
  margin-bottom: 5px;
  text-align: center;
  cursor: default;
}

.InputTime:focus {
  border: 1px solid #006699;
}

.Input:focus {
  border: 1px solid #006699;
}

@keyframes overlayShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes contentShow {
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

/* SELECT STYLES */
.InputSelect {
  width: 250px;
  flex: end 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  box-shadow: 0 0 0 1px black;
  height: 20px;
  border: none;
  margin-bottom: 5px;
}

.InputSelectReportSeguimihnetoSol {
  width: 100%;
  flex: end 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 15px;
  line-height: 1;
  color: black;
  box-shadow: 0 0 0 1px black;
  height: 20px;
  border: none;
  margin-bottom: 5px;
}



/* END SELECT STYLES */
.ButtonWrapper {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  gap: 5px;
}

.ButtonWrapperEdit {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  gap: 5px;
}

.ButtonWrapperEdit .buttons {
  width: 100%;
  justify-content: center;
  display: flex;
  gap: 5px;
}

.checkboxWrapper {
  display: flex;
  justify-content: center;
  gap: 5px;
  margin-bottom: 0px;
  align-self: center;

}



.checkbox {
  width: 20px;
  height: 20px;
  border: 1px solid;
  border-radius: 4px;
  appearance: none;
  background-color: transparent;
  display: grid;
  place-content: center;
}


.checkbox:checked {
  background-color: #006699;
}

.CheckboxRoot {
  background-color: white;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px var(--black-a7);
  transform: translateY(8px);
}

.CheckboxRoot:hover {
  background-color: var(--violet-3);
}

.CheckboxRoot:focus {
  box-shadow: 0 0 0 2px black;
}

.CheckboxIndicator {
  color: #006699;
}



.controlSolicitudes2 {
  display: none;
}

.InputTooltipWrapper>#fechaHoraCita,
#fechaHoraDescargue {
  width: 50px !important;
  text-align: center !important;
}


.InputTimeHour {
  border: 1px solid black;
  padding: 8px;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  background-color: #f9f9f9;
  width: 250px;
  height: 24px;
  box-sizing: border-box;
  margin-bottom: 5px;
  text-align: center;
  cursor: default !important;
}

#horaTransito1 {
  width: 123px !important;
  text-align: center !important;
}

#horaTransito2 {
  width: 122px !important;
  text-align: center !important;
}

/* @media (max-width: 1330px) {
  .rowInfo .col-md-5>.InputTooltipWrapper>label {
    font-size: 13px;    
  }

  .rowInfo .col-md-5>.InputTooltipWrapper{
    margin-bottom: -12px;

  }

  .rowInfo .col-md-5>.InputTooltipWrapper{
    width: 100%;
  }

  .Input,
  .InputSelect {
    height: 20px;
    
  }

  
} */

/* 1. El contenedor debe ser relativo y no flex para que sticky funcione */
.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper {
  position: relative !important;
  display: block !important;
  /* anula el display:flex inline */
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  height: calc(100vh - 250px);
  overflow-y: auto;
  overflow-x: hidden !important;
  scrollbar-width: thin;
  scrollbar-color: #8ea9bd transparent;
}

.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 999px;
  background: #8ea9bd;
  background-clip: padding-box;
}

.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #5d819a;
}

@media (min-width: 768px) {
  html.table-page-lock,
  body:has(.table-page-lock) {
    overflow-y: hidden;
  }

  body:has(.solicitudes-page) #root,
  body:has(.solicitudes-page) .wrapper,
  .solicitudes-page {
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
  }

  .solicitudes-page .layout-container,
  .solicitudes-page .layout-page,
  .solicitudes-page .content-wrapper,
  .solicitudes-page .container-fluid.container-p-y {
    min-height: 0;
  }

  .solicitudes-page .layout-page {
    height: 100%;
  }

  .solicitudes-page .content-wrapper {
    height: auto;
    flex: 1 1 auto;
  }

  .solicitudes-page .content-wrapper {
    overflow: hidden;
  }

  .solicitudes-page .container-fluid.container-p-y {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 0;
    overflow: hidden;
  }

  .solicitudes-page .solicitudes-toolbar,
  .solicitudes-page .solicitudes-filters-row {
    flex: 0 0 auto;
  }

  .solicitudes-page .cardContainerControlDevice.controlSolicitudes {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .solicitudes-page .cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper {
    height: auto !important;
    max-height: 100%;
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden !important;
    overflow-y: auto;
  }
}

/* 2. Asegura que la tabla use layout fijo y ocupe todo el ancho disponible */
.cardContainerControlDevice.controlSolicitudes .solicitudes-table {
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  table-layout: fixed;
  border-collapse: collapse;
}

.cardContainerControlDevice.controlSolicitudes .solicitudes-table th,
.cardContainerControlDevice.controlSolicitudes .solicitudes-table td {
  min-width: 0;
  padding: 7px 6px;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.cardContainerControlDevice.controlSolicitudes .solicitudes-table th {
  font-size: 11px;
}

.solicitud-id-cell {
  cursor: pointer;
  color: #0066cc !important;
}

.solicitud-id-cell strong {
  color: #0066cc !important;
}

.solicitud-id-cell:hover {
  text-decoration: underline;
}

.cardContainerControlDevice.controlSolicitudes .solicitudes-table td:last-child,
.cardContainerControlDevice.controlSolicitudes .solicitudes-table th:last-child {
  padding-left: 2px;
  padding-right: 2px;
  text-align: center;
}

.solicitud-actions-cell {
  position: relative;
  overflow: visible !important;
}

.solicitud-actions-dropdown {
  position: relative;
  display: inline-flex;
  justify-content: center;
}

.solicitud-actions-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent !important;
  color: #006699;
  font-size: 21px;
  line-height: 1;
  cursor: pointer;
}

.solicitud-actions-trigger:hover,
.solicitud-actions-trigger:focus-visible {
  background: transparent !important;
  color: #0176b1;
  outline: 2px solid rgba(0, 102, 153, .25);
  outline-offset: 1px;
}

.solicitud-actions-menu {
  position: absolute;
  top: calc(100% + 3px);
  right: 0;
  z-index: 30;
  display: flex;
  min-width: 145px;
  flex-direction: column;
  padding: 4px;
  border: 1px solid #d6e1e8;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 5px 14px rgba(0, 0, 0, .18);
  text-align: left;
}

.solicitud-actions-menu button {
  display: block;
  width: 100%;
  padding: 7px 9px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #173042;
  font-size: 12px;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
}

.solicitud-actions-menu button i {
  width: 17px;
  margin-right: 6px;
  color: #006699;
  font-size: 15px;
  vertical-align: -2px;
}

.solicitud-actions-menu button:hover,
.solicitud-actions-menu button:focus-visible {
  background: #edf6fb;
  color: #006699;
  outline: none;
}

/* 3. Encabezados pegados al hacer scroll */
#tabla thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  /* por encima de las filas */
  background-color: #006699;
  /* mismo fondo que .FondoHeaderTabla2 */
  color: #fff;
}

/* maestros, transportadora */
.form-transpo-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 1rem;
  background: #fff;
  border-radius: 8px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
}

.form-title {
  text-align: center;
  margin-bottom: 1rem;
  color: #006699;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.form-label {
  margin-left: 2px;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #333;
}

.form-input {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-input:focus {
  outline: none;
  border-color: #006699;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.btn-primary {
  background-color: #006699;
  color: #fff;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #005580;
}

.btn-secondary {
  background-color: #e0e0e0;
  color: #333;
  padding: 0.6rem 1.2rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.btn-secondary:hover {
  background-color: #e0e0e0;
}


@media (max-width: 1024px) {
  .headerInfoContrato {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: start;
    width: 420px;
  }

  #horaTransito1 {
    width: 230px !important;
  }

  #horaTransito2 {
    width: 230px !important;
  }

  .DialogContent {
    overflow-y: scroll;
  }

  .columnsStyles {
    display: flex;
    flex-direction: column !important;
    gap: 5px;
  }

  .ButtonWrapper {
    transform: translateX(0) !important;
  }

  .ButtonWrapperEdit {
    width: 100%;

  }

  .ButtonWrapperEdit .buttons {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .col-md-5 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-md-6 {
    flex: 1 0 auto;
    width: 50.66666667%;
  }


  .buttonSolicitudes {
    width: 40%;
  }

  .FieldsetRow {
    flex-direction: column;
  }

  .labelRowSelect {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 24px;
    margin-top: -40px;

  }

  .ButtonWrapper {
    margin-bottom: 12px;
  }

  .containerMonitoreoTrafico {
    height: auto !important;
  }

  .ContainerTableReportesSolicitudes {
    width: 100%;
    overflow-x: hidden;
  }

  .countersColors {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-self: center;
    justify-content: center;
    margin-bottom: 24px;

  }

  .labelRowSelect .label_trafico {
    width: 100%;
    font-size: 22px;
  }

  .labelRowSelect .form-select {
    width: 100%;
  }

  .Input,
  .InputSelect,
  #unidadCarga,
  #clientConsulta2,
  #destAutorizado,
  #clientConsulta1,
  #clientConsulta3,
  #solicitante,
  #causalCategoria,
  #datosEntrega {
    width: 250px;
  }

  #observacionesServicio .InputTooltipWrapper {
    width: 100%;
  }

  .divForms {
    display: flex;
    flex-direction: column;
    width: 100%;

  }

  #divForms label {
    margin-bottom: -5px;
  }

  #divForms .Fieldset.column>#divForms .InputSelect,
  #divForms select {
    width: 192px !important;
  }


  #divForms2 {
    display: flex;
    flex-direction: column !important;
    width: 100%;
  }

  #divForms2 label {
    margin-bottom: -5px;

  }

  #horaTransito1 {
    width: 250px;
  }

  #horaTransito2 {
    width: 250px;
  }

  #divForms2 .Fieldset.column>#divForms .InputSelect,
  #divForms select {
    width: 192px !important;
  }

  #divForms3 {
    display: flex;
    width: 100% !important;
    flex-direction: column !important;
  }

  #divForms4 {
    display: flex;
    width: 100% !important;
    flex-direction: column !important;
  }

  #divForms4 .Fieldset.column>#destAutorizado,
  #unidadCarga,
  #clientConsulta1,
  #clientConsulta2,
  #clientConsulta3 {
    width: 192px !important;
  }

  #divForms4>#divForms4children {
    display: flex;
    width: 100% !important;
    flex-direction: column !important;
  }

  #divForms5 {
    display: flex;
    width: 100% !important;
    flex-direction: column !important;
  }

  #divForms5 label {
    margin-bottom: -5px;
  }

  #checkbox {
    width: 100% !important;
    display: flex !important;
    text-align: center !important;
    justify-content: start !important;
  }

  .horasYFechas {
    display: flex;
    flex-direction: column;
  }

  .horasYFechas>input {
    height: 38px;
  }


  .InputTooltipWrapper>#fechaHoraCita,
  #fechaHoraDescargue,
  #horaTransito {
    width: 250px !important;
  }



  #datosSolicitante>.Fieldset.column>.InputTooltipWrapper input {
    width: 192px !important;
  }

  #datosEntrega,
  #causalCategoria {
    width: 200px !important;
  }

  #observacionesServicio>.contToltip>label {
    margin-bottom: 0px;
    justify-content: center;
    align-self: center;
    display: flex;

  }

  #fechaHoraCitaProyecto {
    width: 220px !important;
  }

  #observacionesServicio,
  #observacionesText {
    width: 300px !important;
  }

  #datosSolicitante>.Fieldset.column>.contToltip>label,
  #datosCategorias>.Fieldset.column>.contToltip>label {
    margin-bottom: 0;
  }

  #datosCategorias>.Fieldset.column>.InputTooltipWrapper select {
    width: 212px !important;
  }


  .Fieldset.column {
    margin-top: 18px;
  }

  .Fieldset.column>.contToltip {
    margin-bottom: -5px;
  }

  #CatServicioFather {
    display: flex;
    width: 270px;
    flex-direction: column !important;

  }

  .horasYFechas {
    width: 270px;
  }

  #CatServicioFather>.contToltip {
    width: 100%;
    display: flex;
  }

  #catServicio {
    width: 260px !important;

  }
}

@media (min-width: 768px) {
  .col-md-5 {
    flex: 1 0 auto;
    width: 41.66666667%;
  }


}


@media (max-width: 768px) {

  .rowInfo .col-md-5>.InputTooltipWrapper>label {
    font-size: 15px;
  }

  .Input,
  .InputSelect {
    height: 32px;
  }

  .FieldsetRow {
    flex-direction: column;
  }

  .col-md-5 {
    flex: auto;
    width: 52%;
  }

  .InputTooltipWrapper>label {
    display: flex;
  }

  .buttonSolicitudes {
    width: 40%;
  }

  .buttonSolicitudes {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

  }

  .labelRowSelect {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 24px;
    margin-top: -40px;

  }

  .labelRowSelect .label_trafico {
    width: 100%;
    font-size: 22px;
  }

  .labelRowSelect .form-select {
    width: 100%;
  }

  .Input,
  .InputSelect,
  #unidadCarga,
  #clientConsulta2,
  #destAutorizado,
  #clientConsulta1,
  #clientConsulta3,
  #solicitante,
  #catServicio,
  #causalCategoria,
  #datosEntrega {
    width: 250px;
    text-align: center;
  }

  #causalCategoria {
    width: 200px;
  }

  #observacionesServicio .InputTooltipWrapper {
    width: 100%;
  }

  .divForms {
    display: flex;
    flex-direction: column;
    width: 100%;

  }

  #divForms label {
    margin-bottom: -5px;
  }

  #divForms .Fieldset.column>#divForms .InputSelect,
  #divForms select {
    width: 192px !important;
  }


  #divForms2 {
    display: flex;
    flex-direction: column !important;
    width: 100%;
  }

  #divForms2 label {
    margin-bottom: -5px;

  }

  #divForms2 .Fieldset.column>#divForms .InputSelect,
  #divForms select {
    width: 192px !important;
  }

  #divForms3 {
    display: flex;
    width: 100% !important;
    flex-direction: column !important;
  }

  #divForms4 {
    display: flex;
    width: 100% !important;
    flex-direction: column !important;
  }

  #divForms4 .Fieldset.column>#destAutorizado,
  #unidadCarga,
  #clientConsulta1,
  #clientConsulta2,
  #clientConsulta3 {
    width: 192px !important;
  }

  #divForms4>#divForms4children {
    display: flex;
    width: 100% !important;
    flex-direction: column !important;
  }

  #divForms5 {
    display: flex;
    width: 100% !important;
    flex-direction: column !important;
  }

  #divForms5 label {
    margin-bottom: -5px;
  }

  #checkbox {
    width: 100% !important;
    display: flex !important;
    text-align: center !important;
    justify-content: start !important;
  }

  .horasYFechas {
    display: flex;
    flex-direction: column;
  }

  .horasYFechas>input {
    height: 38px;
  }

  .InputTooltipWrapper>#fechaHoraCita,
  #fechaHoraDescargue,
  #horaTransito {
    width: 250px !important;
  }

  #datosSolicitante>.Fieldset.column>.InputTooltipWrapper input {
    width: 192px !important;
  }

  #datosEntrega,
  #causalCategoria {
    width: 260px !important;
  }

  #observacionesServicio>.contToltip>label {
    margin-bottom: 0px;
    justify-content: center;
    align-self: center;
    display: flex;

  }

  #observacionesServicio,
  #observacionesText {
    width: 260px !important;
  }

  #datosSolicitante>.Fieldset.column>.contToltip>label,
  #datosCategorias>.Fieldset.column>.contToltip>label {
    margin-bottom: 0;
  }

  #datosCategorias>.Fieldset.column>.InputTooltipWrapper select {
    width: 212px !important;
  }


  .Fieldset.column {
    margin-top: 18px;
  }

  .Fieldset.column>.contToltip {
    margin-bottom: -5px;
  }

  .controlSolicitudes {
    display: none;
  }

  .controlSolicitudes2 {
    display: block;
    background-color: transparent;

  }

  .containerCardsSolicitudes {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;

  }

  .containerCardsSolicitudes .cardSolicitudesInitial {
    padding: 15px;
    border-radius: 12px;
    background-color: white;
  }

  .containerCardsSolicitudes .cardSolicitudesInitial .header {
    display: flex;
    justify-content: space-between;
    border: none;
    flex-direction: row;
  }





  .containerCardsSolicitudes .cardSolicitudesInitial .header>.opcionesSolicitud {
    display: flex;
    flex-direction: row;
    gap: 10px;

  }
}
.monitoreo-modal .modal-content.monitoreo-modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.26);
}

.monitoreo-modal-header {
  background: #ffffff;
  color: #0f172a;
  border-bottom: 0;
}

.monitoreo-modal-header .modal-title {
  font-weight: 700;
  letter-spacing: 0.2px;
}

.monitoreo-modal-header .btn-close {
  filter: none;
  opacity: 1;
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
  padding: 0.5rem;
  border-radius: 999px;
  background-size: 0.9rem;
  position: static;
  transform: none;
  background-color: #f1f5f9;
  border: 1px solid #d0dbe8;
  box-shadow: none;
  z-index: auto;
}

.monitoreo-modal-body {
  background: linear-gradient(180deg, #f7fbff 0%, #eff5fc 100%);
}

.monitoreo-modern {
  border: none !important;
  border-radius: 14px;
  background: transparent;
  padding: 10px;
  height: calc(100vh - 190px) !important;
  min-height: 620px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.monitoreo-links-row {
  margin-bottom: 12px !important;
}

.monitoreo-links a {
  color: #2368ff;
  text-decoration: none;
  font-weight: 600;
}

.monitoreo-links a:hover {
  text-decoration: underline;
}

.monitoreo-form-card {
  border: none !important;
  border-radius: 12px;
  background: #f9fcff;
  padding: 10px 8px;
  margin-bottom: 10px;
}

.monitoreo-modern .Input,
.monitoreo-modern .InputSelectReportSeguimihnetoSol,
.monitoreo-modern .TextAreaReportSe {
  border: 1px solid #cfe0f0;
  border-radius: 10px;
  background: #fff;
}

.monitoreo-modern .TextAreaReportSe {
  min-height: 94px;
}

.monitoreo-button-wrap {
  margin-top: 6px;
}

.monitoreo-primary-btn {
  border-radius: 10px !important;
  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%) !important;
  border: 0 !important;
  font-weight: 700 !important;
  min-width: 120px;
}

.monitoreo-table-card {
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  overflow: visible;
  flex: 1 1 auto;
  min-height: 280px;
  display: flex;
  flex-direction: column;
}

.monitoreo-table-card .table-responsive {
  border-top: 1px solid #e2ecf5;
  flex: 1 1 auto;
}

.monitoreo-table-card tbody tr:hover {
  background: #edf6ff;
}

.monitoreo-table-card .monitoreo-table-responsive {
  width: 100%;
  max-width: 100%;
  display: block !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  box-sizing: border-box;
  min-height: 220px !important;
  max-height: 320px !important;
  height: 320px !important;
}

.monitoreo-table-card .monitoreo-table-inner {
  width: 100% !important;
  min-width: 0 !important;
  table-layout: fixed;
  margin-bottom: 0;
}

@media (max-width: 992px) {
  .monitoreo-modern {
    height: calc(100vh - 140px) !important;
    min-height: 560px;
  }
}

/* Responsive de Solicitudes siguiendo el patrón visual de Tráfico. */
.solicitudes-page {
  --solicitud-filter-all: #f7f7f7;
  --solicitud-filter-red: #e02b28;
  --solicitud-filter-blue: #006699;
  --solicitud-filter-yellow: #e0a019;
  --solicitud-filter-green: #5de02b;
}

.solicitudes-page,
.solicitudes-page * {
  box-sizing: border-box;
}

.solicitudes-responsive-loader {
  display: none;
}

@media (max-width: 1199px) {
  .solicitudes-responsive-loader {
    position: fixed;
    inset: 0;
    z-index: 14000;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    background: rgba(247, 250, 253, .9);
    color: #174263;
    font-size: 14px;
    font-weight: 700;
    backdrop-filter: blur(3px);
  }

  .solicitudes-responsive-spinner {
    width: 42px;
    height: 42px;
    border: 4px solid #d7e6f1;
    border-top-color: #006699;
    border-radius: 50%;
    animation: solicitudes-responsive-spin .8s linear infinite;
  }

  @keyframes solicitudes-responsive-spin {
    to { transform: rotate(360deg); }
  }
}

.solicitudes-page .solicitudes-navbar-wrap {
  position: relative;
  z-index: 1002;
}

.solicitudes-page .solicitudes-mobile-menu-toggle {
  display: none;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1004;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #006699;
  font-size: 25px;
  cursor: pointer;
}

.solicitudes-page .solicitudes-mobile-menu-toggle:hover,
.solicitudes-page .solicitudes-mobile-menu-toggle:focus-visible {
  background: #eaf4fb;
  outline: none;
}

.solicitudes-page .solicitudes-search .input-group {
  min-height: 44px;
}

.solicitudes-page .solicitudes-search .input-group-text {
  color: #647b91;
  background: #fff;
  border-color: #cfdce8;
}

/* Filtros combinables de solicitudes: opciones únicas con cantidad visible. */
.solicitudes-page .solicitudes-multi-filter {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {
  flex: 0 0 auto;
  width: auto;
  white-space: nowrap;
}

.solicitudes-page .solicitudes-multi-filter > .solicitudes-select__container {
  flex: 1 1 auto;
  min-width: 0;
}

.solicitudes-page .solicitudes-multi-filter .solicitudes-select__control {
  min-height: 44px;
}

.solicitudes-filter-option-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.solicitudes-filter-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 24px;
  padding: 0 7px;
  border-radius: 999px;
  background: #eaf2f8;
  color: #244d6d;
  font-size: 12px;
  font-weight: 800;
  flex: 0 0 auto;
  margin-left: 8px;
}

.solicitudes-page .countersColors .counter-filter {
  cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease, filter .15s ease;
}

.solicitudes-page .countersColors .counter-filter:hover,
.solicitudes-page .countersColors .counter-filter:focus-visible {
  filter: brightness(1.04);
  transform: translateY(-1px);
}

.solicitudes-page .countersColors .counter-filter.is-active {
  outline: 3px solid #174263;
  outline-offset: 2px;
  box-shadow: 0 3px 10px rgba(23, 66, 99, .25);
}

@media (min-width: 768px) {
  .solicitudes-page .solicitudes-multi-filter {
    margin-bottom: 24px;
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {
    font-size: 14px;
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-select__container {
    flex: 1 1;
    min-width: 0;
  }

  .solicitudes-page .countersColors {
    flex-wrap: wrap;
    justify-content: flex-end;
    align-content: center;
    gap: 8px;
  }

  .solicitudes-page .countersColors .counter-filter {
    width: 30px;
    height: 30px;
  }
}

@media (max-width: 767px) {
  .solicitudes-page .solicitudes-multi-filter {
    display: block;
    height: auto;
    min-height: 0;
    padding: 12px 14px;
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {
    margin-bottom: 7px;
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-select__control {
    min-height: 42px;
  }

  .solicitudes-page .countersColors {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

.solicitudes-page .counter-filter span {
  display: none;
}

/* La versión desktop conserva la distribución compacta original. */
@media (min-width: 768px) {
  .solicitudes-page .solicitudes-subtitle {
    display: none;
  }

  .solicitudes-page .solicitudes-city-label {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 30%;
    color: #212529;
    font-weight: 700;
    font-size: 15px;
  }

  .solicitudes-page .solicitudes-city-label i {
    color: #6c8299;
    font-size: 17px;
  }

  .solicitudes-page .labelRowSelect .form-select {
    width: 30%;
  }

  .solicitudes-page .countersColors .counter-filter {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 5px;
    border: 1px solid #000;
    border-radius: 4px;
    color: #000;
    font-weight: 700;
  }

  .solicitudes-page .countersColors .counter-filter strong {
    font-size: inherit;
  }

  .solicitudes-page .countersColors .counter-dot {
    display: none;
  }

  .solicitudes-page .countersColors .counter-filter {
    position: relative;
    cursor: help;
  }

  .solicitudes-page .countersColors .counter-filter:focus-visible {
    outline: 2px solid #1b84c5;
    outline-offset: 2px;
  }

  .solicitudes-page .countersColors .counter-filter::after {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    z-index: 20;
    width: max-content;
    max-width: 230px;
    padding: 7px 9px;
    border-radius: 7px;
    background: #203246;
    color: #fff;
    content: attr(data-tooltip);
    font-size: 11px;
    font-weight: 500;
    line-height: 1.25;
    opacity: 0;
    pointer-events: none;
    transform: translate(-50%, 4px);
    transition: opacity .15s ease, transform .15s ease;
  }

  .solicitudes-page .countersColors .counter-filter:hover::after,
  .solicitudes-page .countersColors .counter-filter:focus-visible::after {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  .solicitudes-page .countersColors .counter-all { background: transparent; }
  .solicitudes-page .countersColors .counter-pending { background: #e02b28; }
  .solicitudes-page .countersColors .counter-progress { background: #006699; }
  .solicitudes-page .countersColors .counter-review { background: #e0a019; }
  .solicitudes-page .countersColors .counter-approved { background: #5de02b; }
}

@media (max-width: 1199px) {
  body.solicitudes-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  body.solicitudes-responsive-page .sidenav---sidenav---_2tBP {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 12000;
    width: 0;
    min-width: 0;
    overflow: hidden;
    transform: translateX(-100%);
    transition: width .2s ease, transform .2s ease;
  }

  body.solicitudes-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {
    width: min(280px, 86vw);
    min-width: min(280px, 86vw);
    overflow-y: auto;
    transform: translateX(0);
    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);
  }

  .solicitudes-page .solicitudes-mobile-menu-toggle {
    display: inline-flex;
  }

  .solicitudes-page #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 62px;
  }

  body.solicitudes-responsive-page .solicitudes-responsive-offcanvas {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh;
    z-index: 13000;
  }

  body.solicitudes-responsive-page .offcanvas-backdrop {
    z-index: 12990;
  }
}

@media (max-width: 767px) {
  .solicitudes-page .content-wrapper {
    padding-bottom: 78px;
  }

  .solicitudes-page #layout-navbar {
    min-height: 60px;
    padding: 4px 8px 4px 58px;
  }

  .solicitudes-page #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
    object-fit: contain;
    object-position: left center;
  }

  .solicitudes-page .container-fluid.container-p-y {
    width: 100%;
    max-width: 100%;
    padding: 12px 16px 86px;
    overflow-x: hidden;
  }

  .solicitudes-page .solicitudes-toolbar {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 10px;
    margin: 0;
  }

  .solicitudes-page .solicitudes-heading,
  .solicitudes-page .solicitudes-search,
  .solicitudes-page .solicitudes-fullscreen {
    width: auto;
    padding: 0;
  }

  .solicitudes-page .solicitudes-heading {
    grid-column: 1 / -1;
  }

  .solicitudes-page .solicitudes-heading .label_trafico {
    display: block;
    margin: 0 !important;
    color: #29445d;
    font-size: 18px !important;
  }

  .solicitudes-page .solicitudes-subtitle {
    display: block;
    margin: -2px 0 0;
    color: #71859a;
    font-size: 12px;
  }

  .solicitudes-page .solicitudes-fullscreen {
    grid-column: 2;
    grid-row: 2;
  }

  .solicitudes-page .solicitudes-fullscreen button {
    width: 44px;
    height: 44px;
    padding: 0;
    border-radius: 10px;
  }

  .solicitudes-page .solicitudes-search {
    grid-column: 1;
    grid-row: 2;
  }

  .solicitudes-page .solicitudes-search .input-group,
  .solicitudes-page .solicitudes-search input {
    width: 100%;
    min-width: 0;
  }

  .solicitudes-page .solicitudes-search .input-group {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: stretch;
    overflow: hidden;
    border-radius: 10px;
  }

  .solicitudes-page .solicitudes-search .input-group-text {
    display: inline-flex;
    flex: 0 0 54px;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .solicitudes-page .solicitudes-search input {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .solicitudes-page .solicitudes-filters-row {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: auto;
    margin: 18px clamp(0px, 3.2vw, 22px) 0;
  }

  .solicitudes-page .solicitudes-filters-row > * {
    width: 100%;
    padding: 0;
  }

  .solicitudes-page .labelRowSelect {
    margin: 0;
    gap: 3px;
    padding: 10px 14px;
    border: 1px solid #e1eaf3;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 5px 16px rgba(31, 55, 80, .06);
    height: 84px;
    min-height: 0;
  }

  .solicitudes-page .solicitudes-city-label {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #6c8299;
    font-size: 13px;
  }

  .solicitudes-page .solicitudes-city-label i {
    color: #6d849c;
    font-size: 19px;
  }

  .solicitudes-page .labelRowSelect .label_trafico,
  .solicitudes-page .labelRowSelect .form-select {
    width: 100%;
    font-size: 14px;
  }

  .solicitudes-page .labelRowSelect .form-select {
    height: 28px;
    padding: 0;
    border: 0;
    color: #193a5c;
    font-size: 16px;
    font-weight: 600;
    background-color: transparent;
  }

  .solicitudes-page .countersColors {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin: 0;
    width: 100%;
    min-width: 0;
    overflow: visible;
  }

  .solicitudes-page .countersColors .counter-filter {
    position: relative;
  }

  .solicitudes-page .countersColors .counter-filter {
    display: flex;
    flex: 1 1;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: 0;
    height: 52px;
    padding: 5px 8px;
    border: 1px solid transparent;
    border-radius: 10px;
    color: #000;
    text-align: center;
    line-height: 1.1;
  }

  .solicitudes-page .counter-filter span {
    display: none;
  }

  .solicitudes-page .counter-filter strong {
    font-size: 22px;
  }

  .solicitudes-page .counter-filter .counter-dot {
    display: none;
  }

  .solicitudes-page .countersColors .counter-all { background: var(--solicitud-filter-all); border-color: #000; }
  .solicitudes-page .countersColors .counter-pending { background: var(--solicitud-filter-red); border-color: #000; }
  .solicitudes-page .countersColors .counter-progress { background: var(--solicitud-filter-blue); border-color: #000; color: #fff; }
  .solicitudes-page .countersColors .counter-review { background: var(--solicitud-filter-yellow); border-color: #000; }
  .solicitudes-page .countersColors .counter-approved { background: var(--solicitud-filter-green); border-color: #000; }

  .solicitudes-page .buttonSolicitudes {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    margin: 0;
  }

  .solicitudes-page .buttonSolicitudes button {
    display: inline-flex;
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
    min-height: 48px;
    justify-content: center;
    padding: 9px 12px;
    border-radius: 10px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
  }

  .solicitudes-page .buttonSolicitudes button:first-child {
    color: #0864bd;
    border: 1px solid #bcdcff;
    background: #edf5ff;
  }

  .solicitudes-page .buttonSolicitudes button:last-child {
    color: #fff;
    background: linear-gradient(135deg, #096fc2, #0063b8);
  }

  .solicitudes-page .buttonSolicitudes button i {
    margin-right: 7px;
    font-size: 20px;
  }

  .solicitudes-page .controlSolicitudes {
    display: none;
  }

  .solicitudes-page .controlSolicitudes2 {
    display: block;
    margin-top: 18px;
  }

  .solicitudes-page .containerCardsSolicitudes {
    gap: 12px;
    margin: 0;
  }

  .solicitudes-page .cardSolicitudesInitial {
    padding: 14px;
    border: 1px solid #dce7f0;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 5px 16px rgba(31, 55, 80, .08);
  }

  .solicitudes-page .cardSolicitudesInitial .header {
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e8eef4;
  }

  .solicitudes-page .cardSolicitudesInitial .header p {
    margin: 0;
    color: #29445d;
    font-size: 16px;
  }

  .solicitudes-page .cardSolicitudesInitial .header p strong {
    font-size: 19px;
  }

  .solicitudes-page .solicitud-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 7px;
    padding: 5px 10px;
    border-radius: 999px;
    background: #edf5ff;
    color: #126bd4;
    font-size: 11px;
    font-weight: 700;
  }

  .solicitudes-page .solicitud-status-badge i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
  }

  .solicitudes-page .solicitud-status-pending .solicitud-status-badge,
  .solicitudes-page .solicitud-status-expired .solicitud-status-badge { background: var(--solicitud-filter-red); color: #fff; }
  .solicitudes-page .solicitud-status-neutral .solicitud-status-badge { background: var(--solicitud-filter-all); color: #000; border: 1px solid #000; }
  .solicitudes-page .solicitud-status-progress .solicitud-status-badge { background: var(--solicitud-filter-blue); color: #fff; }
  .solicitudes-page .solicitud-status-review .solicitud-status-badge { background: var(--solicitud-filter-yellow); color: #000; }
  .solicitudes-page .solicitud-status-approved .solicitud-status-badge { background: var(--solicitud-filter-green); color: #000; }

  .solicitudes-page .cardSolicitudesInitial .opcionesSolicitud {
    gap: 6px;
  }

  .solicitudes-page .cardSolicitudesInitial .opcionesSolicitud button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    padding: 0;
    border: 1px solid #d7e3ec;
    border-radius: 9px;
    background: #f7fbfe;
    color: #006699;
    cursor: pointer;
  }

  .solicitudes-page .cardSolicitudesInitial .opcionesSolicitud button:hover {
    background: #eaf4fb;
  }

  .solicitudes-page .cardSolicitudesInitial .body {
    display: grid;
    gap: 9px;
    padding-top: 2px;
  }

  .solicitudes-page .cardSolicitudesInitial .body p {
    display: grid;
    grid-template-columns: 20px 112px minmax(0, 1fr);
    align-items: center;
    gap: 5px;
    margin: 0;
    color: #516a80;
    font-size: 13px;
    line-height: 1.35;
  }

  .solicitudes-page .cardSolicitudesInitial .body p > i {
    color: #6c849d;
    font-size: 18px;
  }

  .solicitudes-page .cardSolicitudesInitial .body p > span {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .solicitudes-page .cardSolicitudesInitial .body strong {
    color: #243b53;
  }

  .solicitudes-page .cardSolicitudesInitial .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #e8eef4;
    color: #6c8299;
    font-size: 12px;
  }

  .solicitudes-page .cardSolicitudesInitial .card-footer span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .solicitudes-page .cardSolicitudesInitial .card-footer button {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #6c8299;
    font: inherit;
    cursor: pointer;
  }

  .solicitudes-page .cardSolicitudesInitial .card-footer button:hover,
  .solicitudes-page .cardSolicitudesInitial .card-footer button:focus-visible {
    color: #006699;
    outline: none;
  }

  .solicitudes-page .cardSolicitudesInitial .solicitud-extra-details {
    display: grid;
    gap: 7px;
    margin-top: 14px;
    padding: 12px 0;
    border-top: 1px solid #e8eef4;
    border-bottom: 1px solid #e8eef4;
  }

  .solicitudes-page .cardSolicitudesInitial .solicitud-extra-details p {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin: 0;
    color: #516a80;
    font-size: 12px;
    line-height: 1.35;
  }

  .solicitudes-page .cardSolicitudesInitial .solicitud-extra-details strong {
    color: #243b53;
  }

  .solicitudes-page .cardSolicitudesInitial .solicitud-extra-details span {
    min-width: 0;
    text-align: right;
    overflow-wrap: anywhere;
  }

  .solicitudes-page .cardSolicitudesInitial .card-footer i {
    font-size: 17px;
  }
}

/* Los estados también son filtros visibles: etiqueta, color y cantidad. */
@media (min-width: 768px) {
  .solicitudes-page .countersColors .counter-filter {
    width: auto;
    min-width: 42px;
    height: 34px;
    gap: 7px;
    padding: 5px 9px;
    border-radius: 8px;
    white-space: nowrap;
  }

  .solicitudes-page .countersColors .counter-filter span {
    display: inline;
    font-size: 11px;
    font-weight: 700;
  }

  .solicitudes-page .countersColors .counter-filter strong {
    font-size: 14px;
  }

  .solicitudes-page .countersColors .counter-filter .counter-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    flex: 0 0 7px;
    border-radius: 50%;
    background: currentColor;
  }

  .solicitudes-page .countersColors .counter-all .counter-dot {
    border: 1px solid #6c8299;
    background: #fff;
  }
}

.solicitudes-page .solicitudes-status-filter {
  min-width: 0;
  margin-bottom: 24px;
}

.solicitudes-page .solicitudes-status-filter .solicitudes-select__control {
  min-height: 44px;
  background: #fff;
}

.solicitudes-page .solicitudes-status-filter .solicitudes-select__value-container {
  gap: 4px;
}

.solicitudes-page .solicitudes-status-filter .solicitudes-select__multi-value__remove:hover {
  border-radius: 999px;
  background: rgba(23, 66, 99, .12);
  color: #174263;
}

@media (max-width: 767px) {
  .solicitudes-page .solicitudes-status-filter {
    width: 100%;
    margin-bottom: 0;
  }
}

/* Distribución de la cabecera: herramientas, filtros, acciones y tabla no se superponen. */
@media (min-width: 768px) {
  .solicitudes-page .solicitudes-toolbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(320px, 0.95fr);
    align-items: center;
    column-gap: 18px;
    margin: 0 0 18px;
  }

  .solicitudes-page .solicitudes-toolbar > * {
    width: auto;
    min-width: 0;
    padding: 0;
  }

  .solicitudes-page .solicitudes-heading {
    grid-column: 1;
  }

  .solicitudes-page .solicitudes-fullscreen {
    grid-column: 2;
  }

  .solicitudes-page .solicitudes-search {
    grid-column: 3;
  }

  .solicitudes-page .solicitudes-filters-row {
    display: grid;
    grid-template-columns: minmax(280px, 1fr) minmax(280px, 1fr) minmax(330px, 1.25fr);
    align-items: center;
    gap: 18px;
    margin: 0 0 14px;
  }

  .solicitudes-page .solicitudes-filters-row > * {
    width: auto;
    min-width: 0;
    padding: 0;
  }

  .solicitudes-page .solicitudes-multi-filter,
  .solicitudes-page .solicitudes-status-filter {
    margin: 0;
    min-width: 0;
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {
    font-size: 14px;
  }

  .solicitudes-page .solicitudes-actions-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0 0 14px;
  }

  .solicitudes-page .solicitudes-actions-row > * {
    width: auto;
    padding: 0;
  }

  .solicitudes-page .solicitudes-actions-row .buttonSolicitudes {
    width: auto;
    margin: 0;
  }

  .solicitudes-page .solicitudes-multi-filter > .solicitudes-select__container,
  .solicitudes-page .solicitudes-status-filter > .solicitudes-select__container {
    flex: 1 1;
    width: 0;
    min-width: 220px;
  }

  .solicitudes-page .solicitudes-status-filter > .solicitudes-select__container {
    width: 100%;
  }
}

@media (max-width: 767px) {
  .solicitudes-page .solicitudes-actions-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin: 0;
  }

  .solicitudes-page .solicitudes-actions-row > * {
    width: 100%;
    padding: 0;
  }

  .solicitudes-page .solicitudes-actions-row .buttonSolicitudes {
    width: 100%;
  }
}

/* Modo compacto para portátiles de 14" y ventanas desktop reducidas. */
@media (min-width: 768px) and (max-width: 2200px) {
  .solicitudes-page .container-fluid.container-p-y {
    padding-left: clamp(18px, 2.2vw, 32px);
    padding-right: clamp(18px, 2.2vw, 32px);
  }

  .solicitudes-page .solicitudes-toolbar {
    grid-template-columns: minmax(0, 1fr) auto minmax(300px, 1.15fr);
    column-gap: 12px;
    margin-bottom: 14px;
  }

  .solicitudes-page .solicitudes-heading .label_trafico {
    font-size: clamp(18px, 1.6vw, 22px) !important;
  }

  .solicitudes-page .solicitudes-filters-row {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 12px 16px;
    margin-bottom: 12px;
  }

  .solicitudes-page .solicitudes-multi-filter {
    display: grid;
    grid-template-columns: minmax(100px, auto) minmax(0, 1fr);
    align-items: center;
    gap: 8px;
    padding: 0;
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {
    font-size: 13px;
  }

  .solicitudes-page .solicitudes-status-filter {
    grid-column: 1 / -1;
    margin: 0;
  }

  .solicitudes-page .solicitudes-actions-row {
    margin-bottom: 12px;
  }

  .solicitudes-page .buttonSolicitudes button {
    min-height: 42px;
    padding: 8px 12px;
    font-size: 13px;
  }
}

/* Evita que los filtros se dispersen demasiado en monitores anchos. */
@media (min-width: 2201px) {
  .solicitudes-page .solicitudes-toolbar,
  .solicitudes-page .solicitudes-filters-row,
  .solicitudes-page .solicitudes-actions-row {
    width: min(100%, 2050px);
  }

  .solicitudes-page .solicitudes-filters-row {
    grid-template-columns: minmax(480px, 0.95fr) minmax(480px, 0.95fr) minmax(620px, 1.25fr);
    gap: 22px;
  }

  .solicitudes-page .solicitudes-multi-filter {
    gap: 14px;
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {
    font-size: 15px;
  }

  .solicitudes-page .solicitudes-select__control {
    min-height: 48px;
    font-size: 15px;
  }
}

/* En monitores grandes todos los controles viven en una sola fila. */
@media (min-width: 2201px) {
  .solicitudes-page .solicitudes-toolbar {
    margin-bottom: 12px;
  }

  .solicitudes-page .solicitudes-controls-row {
    display: grid;
    grid-template-columns: minmax(360px, 1.25fr) minmax(390px, 1fr) minmax(390px, 1fr) minmax(470px, 1.3fr) auto;
    grid-template-areas: "search city company status fullscreen";
    align-items: center;
    gap: 18px;
    width: min(100%, 2350px);
    margin: 0 0 14px;
  }

  .solicitudes-page .solicitudes-controls-row > * {
    width: auto;
    min-width: 0;
    padding: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search {
    grid-area: search;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen {
    grid-area: fullscreen;
    justify-self: end;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-city-filter {
    grid-area: city;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-company-filter {
    grid-area: company;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {
    grid-area: status;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter,
  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {
    margin: 0;
  }
}

/* En 14" se conserva el modo compacto, pero dentro del mismo bloque de controles. */
@media (min-width: 768px) and (max-width: 2200px) {
  .solicitudes-page .solicitudes-controls-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "search fullscreen"
      "city company"
      "status status";
    gap: 12px 16px;
    width: 100%;
    margin: 0 0 12px;
  }

  .solicitudes-page .solicitudes-controls-row > * {
    width: auto;
    min-width: 0;
    padding: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search {
    grid-area: search;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen {
    grid-area: fullscreen;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-city-filter {
    grid-area: city;
    margin: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-company-filter {
    grid-area: company;
    margin: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {
    grid-area: status;
    margin: 0;
  }
}

@media (max-width: 767px) {
  .solicitudes-page .solicitudes-controls-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "search fullscreen"
      "city city"
      "company company"
      "status status";
    gap: 10px;
    width: 100%;
    margin: 0;
  }

  .solicitudes-page .solicitudes-controls-row > * {
    width: auto;
    min-width: 0;
    padding: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search {
    grid-area: search;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen {
    grid-area: fullscreen;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-city-filter {
    grid-area: city;
    margin: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-company-filter {
    grid-area: company;
    margin: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {
    grid-area: status;
    margin: 0;
  }
}

/* Search móvil alineado visualmente con los selects responsive. */
@media (max-width: 767px) {
  .solicitudes-page .solicitudes-controls-row .solicitudes-search .input-group {
    display: flex !important;
    align-items: stretch;
    width: 100%;
    height: 56px;
    min-height: 56px;
    overflow: hidden;
    border: 1px solid #cfddea;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 4px 14px rgba(31, 55, 80, .06);
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search .input-group-text {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 56px;
    height: 100%;
    padding: 0;
    border: 0;
    border-right: 1px solid #e0e8ef;
    background: transparent;
    color: #58758f;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search input {
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    height: 100%;
    padding: 0 14px;
    border: 0;
    outline: 0;
    background: transparent;
    color: #304f6e;
    font-size: 15px;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search input::placeholder {
    color: #9aabbb;
    opacity: 1;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    min-width: 56px;
    padding: 0;
    border: 1px solid #cfddea;
    border-radius: 16px;
    background: #fff;
    color: #58758f;
    box-shadow: 0 4px 14px rgba(31, 55, 80, .06);
  }
}

/* PC de escritorio: búsqueda, filtros y fullscreen en una sola fila. */
@media (min-width: 1200px) {
  .solicitudes-page .solicitudes-controls-row {
    display: grid;
    grid-template-columns: minmax(300px, 1.2fr) minmax(250px, 1fr) minmax(250px, 1fr) minmax(300px, 1.15fr) 54px;
    grid-template-areas: "search city company status fullscreen";
    align-items: center;
    gap: 14px;
    width: 100%;
    margin: 0 0 14px;
  }

  .solicitudes-page .solicitudes-controls-row > * {
    width: auto;
    min-width: 0;
    padding: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search {
    grid-area: search;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-city-filter {
    grid-area: city;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-company-filter {
    grid-area: company;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {
    grid-area: status;
    margin: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen {
    grid-area: fullscreen;
    justify-self: end;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter {
    display: block;
    margin: 0;
    padding: 0;
  }

  .solicitudes-page .solicitudes-actions-row {
    justify-content: flex-end;
  }
}

/* Sin etiquetas visibles: los selects ocupan directamente toda su columna. */
@media (min-width: 768px) {
  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter {
    display: block;
    padding: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter > .solicitudes-select__container,
  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter > .solicitudes-select__container {
    width: 100%;
    min-width: 0;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search .input-group {
    display: flex;
    align-items: stretch;
    width: 100%;
    height: 54px;
    min-height: 54px;
    overflow: hidden;
    border: 1px solid #cfdce8;
    border-radius: 10px;
    background: #fff;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search .input-group-text {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 54px;
    height: 100%;
    padding: 0;
    border: 0;
    border-right: 1px solid #d9e3ec;
    background: #fff;
    color: #58758f;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search input {
    width: 100%;
    min-width: 0;
    height: 100%;
    padding: 0 14px;
    border: 0;
    outline: 0;
    background: transparent;
    color: #304f6e;
    font-size: 15px;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-search input:focus {
    box-shadow: none;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter .solicitudes-select__control,
  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter .solicitudes-select__control {
    min-height: 54px;
    height: 54px;
    border-radius: 10px;
  }
}

/* Controles de solicitudes: misma escala visual para filtros, acciones y listas. */
.solicitudes-page .solicitudes-filters-row,
.solicitudes-page .solicitudes-actions-row {
  width: 100%;
}

.solicitudes-page .solicitudes-select__container {
  width: 100%;
  min-width: 0;
}

@media (min-width: 768px) {
  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    min-width: 54px;
    padding: 0;
    border: 1px solid #cfdce8;
    border-radius: 10px;
    background: #fff;
    color: #58758f;
    box-shadow: none;
    font-size: 18px;
  }

  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen button:hover,
  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen button:focus-visible {
    border-color: #5d8fba;
    background: #f4f9fc;
    color: #305274;
    outline: none;
  }
}

.solicitudes-page .solicitudes-select__control {
  min-height: 54px !important;
  width: 100%;
  border-radius: 12px;
}

.solicitudes-page .solicitudes-select__value-container {
  min-height: 52px;
  padding: 7px 14px;
}

.solicitudes-page .solicitudes-select__placeholder,
.solicitudes-page .solicitudes-select__single-value {
  font-size: 16px;
}

.solicitudes-page .solicitudes-select__indicators {
  min-height: 52px;
}

.solicitudes-page .solicitudes-select__indicator {
  padding: 10px;
}

.solicitudes-page .solicitudes-status-filter {
  width: 100%;
}

.solicitudes-page .buttonSolicitudes button {
  min-height: 54px;
  border-radius: 12px;
}

@media (min-width: 768px) {
  .solicitudes-page .solicitudes-filters-row {
    align-items: stretch;
  }

  .solicitudes-page .solicitudes-multi-filter {
    min-height: 54px;
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-select__container {
    flex: 1 1;
  }

  .solicitudes-page .solicitudes-status-filter {
    margin-bottom: 0;
  }
}

@media (max-width: 767px) {
  .solicitudes-page .solicitudes-filters-row {
    gap: 14px;
    margin-right: 0;
    margin-left: 0;
  }

  .solicitudes-page .solicitudes-multi-filter,
  .solicitudes-page .solicitudes-status-filter {
    box-sizing: border-box;
    min-height: 112px;
    padding: 14px;
    border: 1px solid #d4e1ee;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 5px 16px rgba(31, 55, 80, .06);
  }

  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {
    margin-bottom: 10px;
    font-size: 15px;
  }

  .solicitudes-page .solicitudes-select__control {
    min-height: 58px !important;
    border-radius: 12px;
  }

  .solicitudes-page .solicitudes-select__value-container,
  .solicitudes-page .solicitudes-select__indicators {
    min-height: 56px;
  }

  .solicitudes-page .solicitudes-select__placeholder,
  .solicitudes-page .solicitudes-select__single-value {
    font-size: 17px;
  }

  .solicitudes-page .solicitudes-actions-row {
    margin-top: 14px;
  }

  .solicitudes-page .buttonSolicitudes button {
    min-height: 56px;
    padding: 12px 14px;
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/solicitudes.css"],"names":[],"mappings":"AAKA;;;EAGE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EAGnB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EAGnB,kDAAkD;AACpD;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;;AAE3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,QAAQ;EACR,0DAA0D;EAC1D,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gGAAgG;EAChG,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,0DAA0D;EAC1D,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;;AAEpB;;AAEA;EACE,uBAAuB;AACzB;;;;AAIA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;;AAGA;EACE,uBAAuB;;AAEzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;;;AAIA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;;;AAIA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,WAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;;;AAIA,sBAAsB;AACtB;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;;AAEpB;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;AACvB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,6BAA6B;AAC/B;;;AAGA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH,0EAA0E;AAC1E;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,kBAAkB;EACpB;;EAEA;;;IAGE,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;EAClB;AACF;;AAEA,6EAA6E;AAC7E;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;EACd,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,uCAAuC;EACvC,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iCAAiC;IACjC,QAAQ;EACV;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,WAAW;;EAEb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;;EAGA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;;EAEnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;EAErB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;;;;;;;IAUE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;;EAEb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;EACzB;;;EAGA;IACE,aAAa;IACb,iCAAiC;IACjC,WAAW;EACb;;EAEA;IACE,mBAAmB;;EAErB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;;;;;IAKE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;;EAGA;;;IAGE,uBAAuB;EACzB;;;;EAIA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;;EAEf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,iCAAiC;;EAEnC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,uBAAuB;;EAEzB;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;;;AAGF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;EAErB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;;EAEnB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;;;;;;;;IAWE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;;EAEb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;EACzB;;;EAGA;IACE,aAAa;IACb,iCAAiC;IACjC,WAAW;EACb;;EAEA;IACE,mBAAmB;;EAErB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;;;;;IAKE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;;EAEf;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,6BAA6B;;EAE/B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;;EAElB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;EACrB;;;;;;EAMA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;EAEX;AACF;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,sJAAsJ;EACtJ,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,wEAAwE;EACxE,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,sCAAsC;IACtC,iBAAiB;EACnB;AACF;;AAEA,qEAAqE;AACrE;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;IACR,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,mCAAmC;IACnC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,0DAA0D;EAC5D;;EAEA;IACE,KAAK,yBAAyB,EAAE;EAClC;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uEAAuE;AACzE;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,oBAAoB;IACpB,+BAA+B;IAC/B,kDAAkD;EACpD;;EAEA;;IAEE,UAAU;IACV,6BAA6B;EAC/B;;EAEA,iDAAiD,uBAAuB,EAAE;EAC1E,qDAAqD,mBAAmB,EAAE;EAC1E,sDAAsD,mBAAmB,EAAE;EAC3E,oDAAoD,mBAAmB,EAAE;EACzE,sDAAsD,mBAAmB,EAAE;AAC7E;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,8CAA8C;EAChD;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,4CAA4C;EAC9C;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,SAAS;EACX;;EAEA;;;IAGE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,sCAAsC;EACxC;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;IAC5C,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA,iDAAiD,uCAAuC,EAAE,kBAAkB,EAAE;EAC9G,qDAAqD,uCAAuC,EAAE,kBAAkB,EAAE;EAClH,sDAAsD,wCAAwC,EAAE,kBAAkB,EAAE,WAAW,EAAE;EACjI,oDAAoD,0CAA0C,EAAE,kBAAkB,EAAE;EACpH,sDAAsD,yCAAyC,EAAE,kBAAkB,EAAE;;EAErH;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,qDAAqD;EACvD;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;wEACsE,uCAAuC,EAAE,WAAW,EAAE;EAC5H,sEAAsE,uCAAuC,EAAE,WAAW,EAAE,sBAAsB,EAAE;EACpJ,uEAAuE,wCAAwC,EAAE,WAAW,EAAE;EAC9H,qEAAqE,0CAA0C,EAAE,WAAW,EAAE;EAC9H,uEAAuE,yCAAyC,EAAE,WAAW,EAAE;;EAE/H;IACE,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,SAAS;IACT,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,0EAA0E;AAC1E;EACE;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,2FAA2F;AAC3F;EACE;IACE,aAAa;IACb,gEAAgE;IAChE,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,kFAAkF;IAClF,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;;IAEE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,SAAW;IACX,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uEAAuE;AACvE;EACE;IACE,sCAAsC;IACtC,uCAAuC;EACzC;;EAEA;IACE,gEAAgE;IAChE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,oDAAoD;IACpD,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yDAAyD;IACzD,mBAAmB;IACnB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,sEAAsE;AACtE;EACE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,wFAAwF;IACxF,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,qEAAqE;AACrE;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,4GAA4G;IAC5G,4DAA4D;IAC5D,mBAAmB;IACnB,SAAS;IACT,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,SAAS;EACX;AACF;;AAEA,oFAAoF;AACpF;EACE;IACE,aAAa;IACb,0CAA0C;IAC1C;;;qBAGiB;IACjB,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;IACb,0CAA0C;IAC1C;;;;qBAIiB;IACjB,SAAS;IACT,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,wBAAwB;IACxB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,UAAU;IACV,SAAS;IACT,+BAA+B;IAC/B,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,4CAA4C;EAC9C;AACF;;AAEA,uEAAuE;AACvE;EACE;IACE,aAAa;IACb,4GAA4G;IAC5G,4DAA4D;IAC5D,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,6EAA6E;AAC7E;EACE;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,UAAU;IACV,SAAS;IACT,+BAA+B;IAC/B,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA,mFAAmF;AACnF;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;IACT,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["@import '@radix-ui/colors/black-alpha.css';\n@import '@radix-ui/colors/green.css';\n@import '@radix-ui/colors/mauve.css';\n@import '@radix-ui/colors/violet.css';\n\nbutton,\nfieldset,\ninput {\n  all: unset;\n}\n\n.headerInfoContrato {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  text-align: end;\n  width: 420px;\n}\n\n\n.headerInfoContrato .class1 {\n  border-radius: 12px;\n  padding: 12px;\n  width: 160px;\n  height: 30px;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  -webkit-box-shadow: 9px 10px 26px -6px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 9px 10px 26px -6px rgba(0, 0, 0, 0.75);\n  box-shadow: 9px 10px 26px -6px rgba(0, 0, 0, 0.45);\n}\n\n.headerInfoContrato .class2 {\n  border-radius: 12px;\n  padding: 12px;\n  width: 250px;\n  height: 30px;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  -webkit-box-shadow: 9px 10px 26px -6px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 9px 10px 26px -6px rgba(0, 0, 0, 0.75);\n  box-shadow: 9px 10px 26px -6px rgba(0, 0, 0, 0.45);\n}\n\n\n\n.labelRowSelect {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-bottom: 24px;\n}\n\n.countersColors {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  align-self: center;\n  justify-content: flex-end;\n\n}\n\n.countersColors>div {\n  padding: 5px;\n  width: 30px;\n  height: 30px;\n  border: 1px solid black;\n  border-radius: 4px;\n  text-align: center;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  font-weight: 700;\n  color: black;\n\n}\n\n.countersColors>.red {\n  background-color: #E02B28;\n}\n\n.countersColors>.yellow {\n  background-color: #E0A019;\n}\n\n.countersColors>.green {\n  background-color: #5DE02B;\n}\n\n.countersColors>.blue {\n  background-color: #006699;\n}\n\n.countersColors>.trans {\n  background-color: transparent;\n}\n\n.labelRowSelect .label_trafico {\n  width: 30%;\n  font-size: 15px;\n}\n\n.labelRowSelect .form-select {\n  width: 30%;\n}\n\n.DialogOverlay {\n  background-color: var(--black-a9);\n  position: fixed;\n  inset: 0;\n  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);\n  z-index: 9999;\n}\n\n.DialogContent {\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90vw;\n  max-width: 90vw;\n  max-height: 100vh;\n  padding: 25px;\n  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);\n  z-index: 9999;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n\n.DialogContent:focus {\n  outline: none;\n}\n\n.rowInfo {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0px;\n}\n\n.DialogTitle {\n  margin: 0;\n  font-weight: 500;\n  color: var(--mauve-12);\n  font-size: 17px;\n}\n\n.DialogDescription {\n  margin: 10px 0 20px;\n  color: var(--mauve-11);\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.Button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 15px;\n  font-size: 15px;\n  line-height: 1;\n  font-weight: 500;\n  height: 35px;\n}\n\n.buttonSolicitudes {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  color: white;\n  justify-content: end;\n}\n\n.buttonSolicitudes button {\n  background-color: #006699;\n  padding: 10px;\n  border-radius: 24px;\n  display: flex;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.buttonSolicitudes button:hover {\n  background-color: #0176b1;\n}\n\n.Button.blue {\n  background-color: #006699;\n  color: white;\n}\n\n.Button.violet {\n  background-color: white;\n  color: var(--violet-11);\n  box-shadow: 0 2px 10px var(--black-a7);\n}\n\n.Button.blue:hover {\n  background-color: #0176b1;\n}\n\n.Button.violet:hover {\n  background-color: var(--mauve-3);\n}\n\n.Button.violet:focus {\n  box-shadow: 0 0 0 2px black;\n}\n\n.Button.green {\n  background-color: var(--green-4);\n  color: var(--green-11);\n}\n\n.Button.green:hover {\n  background-color: var(--green-5);\n}\n\n.Button.green:focus {\n  box-shadow: 0 0 0 2px var(--green-7);\n}\n\n.IconButton {\n  font-family: inherit;\n  border-radius: 100%;\n  height: 25px;\n  width: 25px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--violet-11);\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n.IconButton:hover {\n  background-color: var(--violet-4);\n}\n\n.IconButton:focus {\n  box-shadow: 0 0 0 2px var(--violet-7);\n}\n\n.Fieldset {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.Fieldset.column {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.Fieldset.column label {\n  margin-bottom: -12px;\n}\n\n.FieldsetRow {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n.contToltip {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  margin-bottom: 0px;\n\n}\n\n#observacionesTextReporteSeguimiento {\n  width: 250px !important;\n}\n\n\n\n#unidadCarga,\n#clientConsulta2,\n#destAutorizado,\n#clientConsulta1,\n#clientConsulta3 {\n  width: 192px;\n}\n\n#solicitante {\n  width: 400px;\n}\n\n#catServicio {\n  width: 293px;\n  margin-bottom: 0;\n}\n\n#CatServicioFather>.contToltip {\n  margin-bottom: 0px;\n}\n\n\n#causalCategoria,\n#datosEntrega {\n  width: 420px;\n}\n\n#observacionesServicio {\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n  display: flex;\n}\n\n#observacionesServicio .InputTooltipWrapper {\n  width: 79%;\n}\n\n.Label {\n  font-size: 15px;\n  color: black;\n  font-weight: 700;\n  margin-bottom: 0px;\n  padding-left: 0px;\n  align-self: center;\n}\n\n.LabelTracking {\n  font-size: 12px;\n  color: black;\n  font-weight: 700;\n  margin-bottom: 0px;\n  padding-left: 0px;\n  align-self: center;\n}\n\n.InputTooltipWrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 0px;\n}\n\n.reporteSeolicitud {\n  display: flex;\n  text-align: start;\n  justify-content: start;\n}\n\n.reporteSeolicitudInputt {\n  display: flex;\n  text-align: start;\n  justify-content: flex-start;\n}\n\n.reporteMonitoreoInputt {\n  display: flex;\n  text-align: start;\n  justify-content: flex-start;\n  transform: translateX(-4px);\n}\n\n.reporteMonitoreoInputt2 {\n  display: flex;\n  text-align: start;\n  justify-content: flex-start;\n  transform: translateX(-4px);\n}\n\n\n#fechaHoraCitaReport {\n  width: 100px !important;\n\n}\n\n#guiaContenedorNro {\n  width: 10px;\n}\n\n.InputTooltipWrapper label {\n  margin-bottom: 0;\n  justify-content: end;\n  display: flex;\n  margin-top: -3px;\n}\n\n.Input {\n  width: 230px;\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: start;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  height: 20px;\n  margin-bottom: 5px;\n  border: 1px solid black;\n}\n\n\n\n.FechaProyecto {\n  width: 230px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  height: 20px;\n  margin-bottom: 5px;\n  border: 1px solid black;\n}\n\n\n\n#placaTruck,\n#placaRemolque {\n  text-transform: uppercase;\n}\n\n.TextArea {\n  width: 100%;\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  box-shadow: 0 0 0 1px black;\n  height: 47px;\n  border: none;\n}\n\n.TextArea1 {\n  width: 83%;\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  box-shadow: 0 0 0 1px black;\n  height: 60px;\n  border: none;\n}\n\n.TextAreaMult {\n  width: 100%;\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  box-shadow: 0 0 0 1px black;\n  height: 190px;\n  border: none;\n}\n\n.TextAreaReportSe {\n  width: 290px;\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  box-shadow: 0 0 0 1px black;\n  height: 70px;\n  border: none;\n}\n\n.TextAreaReportSe2 {\n  width: 401px;\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  box-shadow: 0 0 0 1px black;\n  height: 70px;\n  border: none;\n}\n\n/* Tabloa de reportes cambios  */\n.tr-th-report td {\n  height: 20px !important;\n}\n\n#tabla {\n  max-height: 160px;\n  overflow: auto;\n}\n\n.InputTime {\n  border: 1px solid black;\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #333;\n  background-color: #f9f9f9;\n  width: 250px;\n  height: 24px;\n  box-sizing: border-box;\n  margin-bottom: 5px;\n  text-align: center;\n  cursor: default;\n}\n\n.InputTime:focus {\n  border: 1px solid #006699;\n}\n\n.Input:focus {\n  border: 1px solid #006699;\n}\n\n@keyframes overlayShow {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes contentShow {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -48%) scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n/* SELECT STYLES */\n.InputSelect {\n  width: 250px;\n  flex: end;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  box-shadow: 0 0 0 1px black;\n  height: 20px;\n  border: none;\n  margin-bottom: 5px;\n}\n\n.InputSelectReportSeguimihnetoSol {\n  width: 100%;\n  flex: end;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 15px;\n  line-height: 1;\n  color: black;\n  box-shadow: 0 0 0 1px black;\n  height: 20px;\n  border: none;\n  margin-bottom: 5px;\n}\n\n\n\n/* END SELECT STYLES */\n.ButtonWrapper {\n  display: flex;\n  margin-top: 10px;\n  justify-content: center;\n  gap: 5px;\n}\n\n.ButtonWrapperEdit {\n  display: flex;\n  margin-top: 10px;\n  justify-content: center;\n  gap: 5px;\n}\n\n.ButtonWrapperEdit .buttons {\n  width: 100%;\n  justify-content: center;\n  display: flex;\n  gap: 5px;\n}\n\n.checkboxWrapper {\n  display: flex;\n  justify-content: center;\n  gap: 5px;\n  margin-bottom: 0px;\n  align-self: center;\n\n}\n\n\n\n.checkbox {\n  width: 20px;\n  height: 20px;\n  border: 1px solid;\n  border-radius: 4px;\n  appearance: none;\n  background-color: transparent;\n  display: grid;\n  place-content: center;\n}\n\n\n.checkbox:checked {\n  background-color: #006699;\n}\n\n.CheckboxRoot {\n  background-color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 10px var(--black-a7);\n  transform: translateY(8px);\n}\n\n.CheckboxRoot:hover {\n  background-color: var(--violet-3);\n}\n\n.CheckboxRoot:focus {\n  box-shadow: 0 0 0 2px black;\n}\n\n.CheckboxIndicator {\n  color: #006699;\n}\n\n\n\n.controlSolicitudes2 {\n  display: none;\n}\n\n.InputTooltipWrapper>#fechaHoraCita,\n#fechaHoraDescargue {\n  width: 50px !important;\n  text-align: center !important;\n}\n\n\n.InputTimeHour {\n  border: 1px solid black;\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #333;\n  background-color: #f9f9f9;\n  width: 250px;\n  height: 24px;\n  box-sizing: border-box;\n  margin-bottom: 5px;\n  text-align: center;\n  cursor: default !important;\n}\n\n#horaTransito1 {\n  width: 123px !important;\n  text-align: center !important;\n}\n\n#horaTransito2 {\n  width: 122px !important;\n  text-align: center !important;\n}\n\n/* @media (max-width: 1330px) {\n  .rowInfo .col-md-5>.InputTooltipWrapper>label {\n    font-size: 13px;    \n  }\n\n  .rowInfo .col-md-5>.InputTooltipWrapper{\n    margin-bottom: -12px;\n\n  }\n\n  .rowInfo .col-md-5>.InputTooltipWrapper{\n    width: 100%;\n  }\n\n  .Input,\n  .InputSelect {\n    height: 20px;\n    \n  }\n\n  \n} */\n\n/* 1. El contenedor debe ser relativo y no flex para que sticky funcione */\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper {\n  position: relative !important;\n  display: block !important;\n  /* anula el display:flex inline */\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  height: calc(100vh - 250px);\n  overflow-y: auto;\n  overflow-x: hidden !important;\n  scrollbar-width: thin;\n  scrollbar-color: #8ea9bd transparent;\n}\n\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper::-webkit-scrollbar-thumb {\n  border: 2px solid transparent;\n  border-radius: 999px;\n  background: #8ea9bd;\n  background-clip: padding-box;\n}\n\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background-color: #5d819a;\n}\n\n@media (min-width: 768px) {\n  html.table-page-lock,\n  body:has(.table-page-lock) {\n    overflow-y: hidden;\n  }\n\n  body:has(.solicitudes-page) #root,\n  body:has(.solicitudes-page) .wrapper,\n  .solicitudes-page {\n    height: 100dvh;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .solicitudes-page .layout-container,\n  .solicitudes-page .layout-page,\n  .solicitudes-page .content-wrapper,\n  .solicitudes-page .container-fluid.container-p-y {\n    min-height: 0;\n  }\n\n  .solicitudes-page .layout-page {\n    height: 100%;\n  }\n\n  .solicitudes-page .content-wrapper {\n    height: auto;\n    flex: 1 1 auto;\n  }\n\n  .solicitudes-page .content-wrapper {\n    overflow: hidden;\n  }\n\n  .solicitudes-page .container-fluid.container-p-y {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  .solicitudes-page .solicitudes-toolbar,\n  .solicitudes-page .solicitudes-filters-row {\n    flex: 0 0 auto;\n  }\n\n  .solicitudes-page .cardContainerControlDevice.controlSolicitudes {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .solicitudes-page .cardContainerControlDevice.controlSolicitudes .solicitudes-table-wrapper {\n    height: auto !important;\n    max-height: 100%;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-x: hidden !important;\n    overflow-y: auto;\n  }\n}\n\n/* 2. Asegura que la tabla use layout fijo y ocupe todo el ancho disponible */\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table {\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table th,\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table td {\n  min-width: 0;\n  padding: 7px 6px;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table th {\n  font-size: 11px;\n}\n\n.solicitud-id-cell {\n  cursor: pointer;\n  color: #0066cc !important;\n}\n\n.solicitud-id-cell strong {\n  color: #0066cc !important;\n}\n\n.solicitud-id-cell:hover {\n  text-decoration: underline;\n}\n\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table td:last-child,\n.cardContainerControlDevice.controlSolicitudes .solicitudes-table th:last-child {\n  padding-left: 2px;\n  padding-right: 2px;\n  text-align: center;\n}\n\n.solicitud-actions-cell {\n  position: relative;\n  overflow: visible !important;\n}\n\n.solicitud-actions-dropdown {\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n}\n\n.solicitud-actions-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: transparent !important;\n  color: #006699;\n  font-size: 21px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.solicitud-actions-trigger:hover,\n.solicitud-actions-trigger:focus-visible {\n  background: transparent !important;\n  color: #0176b1;\n  outline: 2px solid rgba(0, 102, 153, .25);\n  outline-offset: 1px;\n}\n\n.solicitud-actions-menu {\n  position: absolute;\n  top: calc(100% + 3px);\n  right: 0;\n  z-index: 30;\n  display: flex;\n  min-width: 145px;\n  flex-direction: column;\n  padding: 4px;\n  border: 1px solid #d6e1e8;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: 0 5px 14px rgba(0, 0, 0, .18);\n  text-align: left;\n}\n\n.solicitud-actions-menu button {\n  display: block;\n  width: 100%;\n  padding: 7px 9px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: #173042;\n  font-size: 12px;\n  line-height: 1.2;\n  text-align: left;\n  cursor: pointer;\n}\n\n.solicitud-actions-menu button i {\n  width: 17px;\n  margin-right: 6px;\n  color: #006699;\n  font-size: 15px;\n  vertical-align: -2px;\n}\n\n.solicitud-actions-menu button:hover,\n.solicitud-actions-menu button:focus-visible {\n  background: #edf6fb;\n  color: #006699;\n  outline: none;\n}\n\n/* 3. Encabezados pegados al hacer scroll */\n#tabla thead th {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  /* por encima de las filas */\n  background-color: #006699;\n  /* mismo fondo que .FondoHeaderTabla2 */\n  color: #fff;\n}\n\n/* maestros, transportadora */\n.form-transpo-container {\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 1rem;\n  background: #fff;\n  border-radius: 8px;\n  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */\n}\n\n.form-title {\n  text-align: center;\n  margin-bottom: 1rem;\n  color: #006699;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n}\n\n.form-label {\n  margin-left: 2px;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.form-input {\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #006699;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.btn-primary {\n  background-color: #006699;\n  color: #fff;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-primary:hover {\n  background-color: #005580;\n}\n\n.btn-secondary {\n  background-color: #e0e0e0;\n  color: #333;\n  padding: 0.6rem 1.2rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-secondary:hover {\n  background-color: #e0e0e0;\n}\n\n\n@media (max-width: 1024px) {\n  .headerInfoContrato {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    text-align: start;\n    width: 420px;\n  }\n\n  #horaTransito1 {\n    width: 230px !important;\n  }\n\n  #horaTransito2 {\n    width: 230px !important;\n  }\n\n  .DialogContent {\n    overflow-y: scroll;\n  }\n\n  .columnsStyles {\n    display: flex;\n    flex-direction: column !important;\n    gap: 5px;\n  }\n\n  .ButtonWrapper {\n    transform: translateX(0) !important;\n  }\n\n  .ButtonWrapperEdit {\n    width: 100%;\n\n  }\n\n  .ButtonWrapperEdit .buttons {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-md-6 {\n    flex: 1 0 auto;\n    width: 50.66666667%;\n  }\n\n\n  .buttonSolicitudes {\n    width: 40%;\n  }\n\n  .FieldsetRow {\n    flex-direction: column;\n  }\n\n  .labelRowSelect {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    margin-bottom: 24px;\n    margin-top: -40px;\n\n  }\n\n  .ButtonWrapper {\n    margin-bottom: 12px;\n  }\n\n  .containerMonitoreoTrafico {\n    height: auto !important;\n  }\n\n  .ContainerTableReportesSolicitudes {\n    width: 100%;\n    overflow-x: hidden;\n  }\n\n  .countersColors {\n    display: flex;\n    flex-direction: row;\n    gap: 5px;\n    align-self: center;\n    justify-content: center;\n    margin-bottom: 24px;\n\n  }\n\n  .labelRowSelect .label_trafico {\n    width: 100%;\n    font-size: 22px;\n  }\n\n  .labelRowSelect .form-select {\n    width: 100%;\n  }\n\n  .Input,\n  .InputSelect,\n  #unidadCarga,\n  #clientConsulta2,\n  #destAutorizado,\n  #clientConsulta1,\n  #clientConsulta3,\n  #solicitante,\n  #causalCategoria,\n  #datosEntrega {\n    width: 250px;\n  }\n\n  #observacionesServicio .InputTooltipWrapper {\n    width: 100%;\n  }\n\n  .divForms {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n  }\n\n  #divForms label {\n    margin-bottom: -5px;\n  }\n\n  #divForms .Fieldset.column>#divForms .InputSelect,\n  #divForms select {\n    width: 192px !important;\n  }\n\n\n  #divForms2 {\n    display: flex;\n    flex-direction: column !important;\n    width: 100%;\n  }\n\n  #divForms2 label {\n    margin-bottom: -5px;\n\n  }\n\n  #horaTransito1 {\n    width: 250px;\n  }\n\n  #horaTransito2 {\n    width: 250px;\n  }\n\n  #divForms2 .Fieldset.column>#divForms .InputSelect,\n  #divForms select {\n    width: 192px !important;\n  }\n\n  #divForms3 {\n    display: flex;\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n\n  #divForms4 {\n    display: flex;\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n\n  #divForms4 .Fieldset.column>#destAutorizado,\n  #unidadCarga,\n  #clientConsulta1,\n  #clientConsulta2,\n  #clientConsulta3 {\n    width: 192px !important;\n  }\n\n  #divForms4>#divForms4children {\n    display: flex;\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n\n  #divForms5 {\n    display: flex;\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n\n  #divForms5 label {\n    margin-bottom: -5px;\n  }\n\n  #checkbox {\n    width: 100% !important;\n    display: flex !important;\n    text-align: center !important;\n    justify-content: start !important;\n  }\n\n  .horasYFechas {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .horasYFechas>input {\n    height: 38px;\n  }\n\n\n  .InputTooltipWrapper>#fechaHoraCita,\n  #fechaHoraDescargue,\n  #horaTransito {\n    width: 250px !important;\n  }\n\n\n\n  #datosSolicitante>.Fieldset.column>.InputTooltipWrapper input {\n    width: 192px !important;\n  }\n\n  #datosEntrega,\n  #causalCategoria {\n    width: 200px !important;\n  }\n\n  #observacionesServicio>.contToltip>label {\n    margin-bottom: 0px;\n    justify-content: center;\n    align-self: center;\n    display: flex;\n\n  }\n\n  #fechaHoraCitaProyecto {\n    width: 220px !important;\n  }\n\n  #observacionesServicio,\n  #observacionesText {\n    width: 300px !important;\n  }\n\n  #datosSolicitante>.Fieldset.column>.contToltip>label,\n  #datosCategorias>.Fieldset.column>.contToltip>label {\n    margin-bottom: 0;\n  }\n\n  #datosCategorias>.Fieldset.column>.InputTooltipWrapper select {\n    width: 212px !important;\n  }\n\n\n  .Fieldset.column {\n    margin-top: 18px;\n  }\n\n  .Fieldset.column>.contToltip {\n    margin-bottom: -5px;\n  }\n\n  #CatServicioFather {\n    display: flex;\n    width: 270px;\n    flex-direction: column !important;\n\n  }\n\n  .horasYFechas {\n    width: 270px;\n  }\n\n  #CatServicioFather>.contToltip {\n    width: 100%;\n    display: flex;\n  }\n\n  #catServicio {\n    width: 260px !important;\n\n  }\n}\n\n@media (min-width: 768px) {\n  .col-md-5 {\n    flex: 1 0 auto;\n    width: 41.66666667%;\n  }\n\n\n}\n\n\n@media (max-width: 768px) {\n\n  .rowInfo .col-md-5>.InputTooltipWrapper>label {\n    font-size: 15px;\n  }\n\n  .Input,\n  .InputSelect {\n    height: 32px;\n  }\n\n  .FieldsetRow {\n    flex-direction: column;\n  }\n\n  .col-md-5 {\n    flex: auto;\n    width: 52%;\n  }\n\n  .InputTooltipWrapper>label {\n    display: flex;\n  }\n\n  .buttonSolicitudes {\n    width: 40%;\n  }\n\n  .buttonSolicitudes {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 24px;\n\n  }\n\n  .labelRowSelect {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    margin-bottom: 24px;\n    margin-top: -40px;\n\n  }\n\n  .labelRowSelect .label_trafico {\n    width: 100%;\n    font-size: 22px;\n  }\n\n  .labelRowSelect .form-select {\n    width: 100%;\n  }\n\n  .Input,\n  .InputSelect,\n  #unidadCarga,\n  #clientConsulta2,\n  #destAutorizado,\n  #clientConsulta1,\n  #clientConsulta3,\n  #solicitante,\n  #catServicio,\n  #causalCategoria,\n  #datosEntrega {\n    width: 250px;\n    text-align: center;\n  }\n\n  #causalCategoria {\n    width: 200px;\n  }\n\n  #observacionesServicio .InputTooltipWrapper {\n    width: 100%;\n  }\n\n  .divForms {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n  }\n\n  #divForms label {\n    margin-bottom: -5px;\n  }\n\n  #divForms .Fieldset.column>#divForms .InputSelect,\n  #divForms select {\n    width: 192px !important;\n  }\n\n\n  #divForms2 {\n    display: flex;\n    flex-direction: column !important;\n    width: 100%;\n  }\n\n  #divForms2 label {\n    margin-bottom: -5px;\n\n  }\n\n  #divForms2 .Fieldset.column>#divForms .InputSelect,\n  #divForms select {\n    width: 192px !important;\n  }\n\n  #divForms3 {\n    display: flex;\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n\n  #divForms4 {\n    display: flex;\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n\n  #divForms4 .Fieldset.column>#destAutorizado,\n  #unidadCarga,\n  #clientConsulta1,\n  #clientConsulta2,\n  #clientConsulta3 {\n    width: 192px !important;\n  }\n\n  #divForms4>#divForms4children {\n    display: flex;\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n\n  #divForms5 {\n    display: flex;\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n\n  #divForms5 label {\n    margin-bottom: -5px;\n  }\n\n  #checkbox {\n    width: 100% !important;\n    display: flex !important;\n    text-align: center !important;\n    justify-content: start !important;\n  }\n\n  .horasYFechas {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .horasYFechas>input {\n    height: 38px;\n  }\n\n  .InputTooltipWrapper>#fechaHoraCita,\n  #fechaHoraDescargue,\n  #horaTransito {\n    width: 250px !important;\n  }\n\n  #datosSolicitante>.Fieldset.column>.InputTooltipWrapper input {\n    width: 192px !important;\n  }\n\n  #datosEntrega,\n  #causalCategoria {\n    width: 260px !important;\n  }\n\n  #observacionesServicio>.contToltip>label {\n    margin-bottom: 0px;\n    justify-content: center;\n    align-self: center;\n    display: flex;\n\n  }\n\n  #observacionesServicio,\n  #observacionesText {\n    width: 260px !important;\n  }\n\n  #datosSolicitante>.Fieldset.column>.contToltip>label,\n  #datosCategorias>.Fieldset.column>.contToltip>label {\n    margin-bottom: 0;\n  }\n\n  #datosCategorias>.Fieldset.column>.InputTooltipWrapper select {\n    width: 212px !important;\n  }\n\n\n  .Fieldset.column {\n    margin-top: 18px;\n  }\n\n  .Fieldset.column>.contToltip {\n    margin-bottom: -5px;\n  }\n\n  .controlSolicitudes {\n    display: none;\n  }\n\n  .controlSolicitudes2 {\n    display: block;\n    background-color: transparent;\n\n  }\n\n  .containerCardsSolicitudes {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 24px;\n\n  }\n\n  .containerCardsSolicitudes .cardSolicitudesInitial {\n    padding: 15px;\n    border-radius: 12px;\n    background-color: white;\n  }\n\n  .containerCardsSolicitudes .cardSolicitudesInitial .header {\n    display: flex;\n    justify-content: space-between;\n    border: none;\n    flex-direction: row;\n  }\n\n\n\n\n\n  .containerCardsSolicitudes .cardSolicitudesInitial .header>.opcionesSolicitud {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n\n  }\n}\n.monitoreo-modal .modal-content.monitoreo-modal-content {\n  border: 0;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.26);\n}\n\n.monitoreo-modal-header {\n  background: #ffffff;\n  color: #0f172a;\n  border-bottom: 0;\n}\n\n.monitoreo-modal-header .modal-title {\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.monitoreo-modal-header .btn-close {\n  filter: none;\n  opacity: 1;\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n  padding: 0.5rem;\n  border-radius: 999px;\n  background-size: 0.9rem;\n  position: static;\n  transform: none;\n  background-color: #f1f5f9;\n  border: 1px solid #d0dbe8;\n  box-shadow: none;\n  z-index: auto;\n}\n\n.monitoreo-modal-body {\n  background: linear-gradient(180deg, #f7fbff 0%, #eff5fc 100%);\n}\n\n.monitoreo-modern {\n  border: none !important;\n  border-radius: 14px;\n  background: transparent;\n  padding: 10px;\n  height: calc(100vh - 190px) !important;\n  min-height: 620px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.monitoreo-links-row {\n  margin-bottom: 12px !important;\n}\n\n.monitoreo-links a {\n  color: #2368ff;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.monitoreo-links a:hover {\n  text-decoration: underline;\n}\n\n.monitoreo-form-card {\n  border: none !important;\n  border-radius: 12px;\n  background: #f9fcff;\n  padding: 10px 8px;\n  margin-bottom: 10px;\n}\n\n.monitoreo-modern .Input,\n.monitoreo-modern .InputSelectReportSeguimihnetoSol,\n.monitoreo-modern .TextAreaReportSe {\n  border: 1px solid #cfe0f0;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.monitoreo-modern .TextAreaReportSe {\n  min-height: 94px;\n}\n\n.monitoreo-button-wrap {\n  margin-top: 6px;\n}\n\n.monitoreo-primary-btn {\n  border-radius: 10px !important;\n  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%) !important;\n  border: 0 !important;\n  font-weight: 700 !important;\n  min-width: 120px;\n}\n\n.monitoreo-table-card {\n  border: none !important;\n  border-radius: 12px !important;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n  overflow: visible;\n  flex: 1 1 auto;\n  min-height: 280px;\n  display: flex;\n  flex-direction: column;\n}\n\n.monitoreo-table-card .table-responsive {\n  border-top: 1px solid #e2ecf5;\n  flex: 1 1 auto;\n}\n\n.monitoreo-table-card tbody tr:hover {\n  background: #edf6ff;\n}\n\n.monitoreo-table-card .monitoreo-table-responsive {\n  width: 100%;\n  max-width: 100%;\n  display: block !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n  box-sizing: border-box;\n  min-height: 220px !important;\n  max-height: 320px !important;\n  height: 320px !important;\n}\n\n.monitoreo-table-card .monitoreo-table-inner {\n  width: 100% !important;\n  min-width: 0 !important;\n  table-layout: fixed;\n  margin-bottom: 0;\n}\n\n@media (max-width: 992px) {\n  .monitoreo-modern {\n    height: calc(100vh - 140px) !important;\n    min-height: 560px;\n  }\n}\n\n/* Responsive de Solicitudes siguiendo el patrón visual de Tráfico. */\n.solicitudes-page {\n  --solicitud-filter-all: #f7f7f7;\n  --solicitud-filter-red: #e02b28;\n  --solicitud-filter-blue: #006699;\n  --solicitud-filter-yellow: #e0a019;\n  --solicitud-filter-green: #5de02b;\n}\n\n.solicitudes-page,\n.solicitudes-page * {\n  box-sizing: border-box;\n}\n\n.solicitudes-responsive-loader {\n  display: none;\n}\n\n@media (max-width: 1199px) {\n  .solicitudes-responsive-loader {\n    position: fixed;\n    inset: 0;\n    z-index: 14000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 12px;\n    background: rgba(247, 250, 253, .9);\n    color: #174263;\n    font-size: 14px;\n    font-weight: 700;\n    backdrop-filter: blur(3px);\n  }\n\n  .solicitudes-responsive-spinner {\n    width: 42px;\n    height: 42px;\n    border: 4px solid #d7e6f1;\n    border-top-color: #006699;\n    border-radius: 50%;\n    animation: solicitudes-responsive-spin .8s linear infinite;\n  }\n\n  @keyframes solicitudes-responsive-spin {\n    to { transform: rotate(360deg); }\n  }\n}\n\n.solicitudes-page .solicitudes-navbar-wrap {\n  position: relative;\n  z-index: 1002;\n}\n\n.solicitudes-page .solicitudes-mobile-menu-toggle {\n  display: none;\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  z-index: 1004;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #006699;\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.solicitudes-page .solicitudes-mobile-menu-toggle:hover,\n.solicitudes-page .solicitudes-mobile-menu-toggle:focus-visible {\n  background: #eaf4fb;\n  outline: none;\n}\n\n.solicitudes-page .solicitudes-search .input-group {\n  min-height: 44px;\n}\n\n.solicitudes-page .solicitudes-search .input-group-text {\n  color: #647b91;\n  background: #fff;\n  border-color: #cfdce8;\n}\n\n/* Filtros combinables de solicitudes: opciones únicas con cantidad visible. */\n.solicitudes-page .solicitudes-multi-filter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {\n  flex: 0 0 auto;\n  width: auto;\n  white-space: nowrap;\n}\n\n.solicitudes-page .solicitudes-multi-filter > .solicitudes-select__container {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.solicitudes-page .solicitudes-multi-filter .solicitudes-select__control {\n  min-height: 44px;\n}\n\n.solicitudes-filter-option-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n}\n\n.solicitudes-filter-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 26px;\n  height: 24px;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: #eaf2f8;\n  color: #244d6d;\n  font-size: 12px;\n  font-weight: 800;\n  flex: 0 0 auto;\n  margin-left: 8px;\n}\n\n.solicitudes-page .countersColors .counter-filter {\n  cursor: pointer;\n  transition: transform .15s ease, box-shadow .15s ease, filter .15s ease;\n}\n\n.solicitudes-page .countersColors .counter-filter:hover,\n.solicitudes-page .countersColors .counter-filter:focus-visible {\n  filter: brightness(1.04);\n  transform: translateY(-1px);\n}\n\n.solicitudes-page .countersColors .counter-filter.is-active {\n  outline: 3px solid #174263;\n  outline-offset: 2px;\n  box-shadow: 0 3px 10px rgba(23, 66, 99, .25);\n}\n\n@media (min-width: 768px) {\n  .solicitudes-page .solicitudes-multi-filter {\n    margin-bottom: 24px;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {\n    font-size: 14px;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-select__container {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .solicitudes-page .countersColors {\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    align-content: center;\n    gap: 8px;\n  }\n\n  .solicitudes-page .countersColors .counter-filter {\n    width: 30px;\n    height: 30px;\n  }\n}\n\n@media (max-width: 767px) {\n  .solicitudes-page .solicitudes-multi-filter {\n    display: block;\n    height: auto;\n    min-height: 0;\n    padding: 12px 14px;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {\n    margin-bottom: 7px;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-select__control {\n    min-height: 42px;\n  }\n\n  .solicitudes-page .countersColors {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n\n.solicitudes-page .counter-filter span {\n  display: none;\n}\n\n/* La versión desktop conserva la distribución compacta original. */\n@media (min-width: 768px) {\n  .solicitudes-page .solicitudes-subtitle {\n    display: none;\n  }\n\n  .solicitudes-page .solicitudes-city-label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    width: 30%;\n    color: #212529;\n    font-weight: 700;\n    font-size: 15px;\n  }\n\n  .solicitudes-page .solicitudes-city-label i {\n    color: #6c8299;\n    font-size: 17px;\n  }\n\n  .solicitudes-page .labelRowSelect .form-select {\n    width: 30%;\n  }\n\n  .solicitudes-page .countersColors .counter-filter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    padding: 5px;\n    border: 1px solid #000;\n    border-radius: 4px;\n    color: #000;\n    font-weight: 700;\n  }\n\n  .solicitudes-page .countersColors .counter-filter strong {\n    font-size: inherit;\n  }\n\n  .solicitudes-page .countersColors .counter-dot {\n    display: none;\n  }\n\n  .solicitudes-page .countersColors .counter-filter {\n    position: relative;\n    cursor: help;\n  }\n\n  .solicitudes-page .countersColors .counter-filter:focus-visible {\n    outline: 2px solid #1b84c5;\n    outline-offset: 2px;\n  }\n\n  .solicitudes-page .countersColors .counter-filter::after {\n    position: absolute;\n    bottom: calc(100% + 8px);\n    left: 50%;\n    z-index: 20;\n    width: max-content;\n    max-width: 230px;\n    padding: 7px 9px;\n    border-radius: 7px;\n    background: #203246;\n    color: #fff;\n    content: attr(data-tooltip);\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 1.25;\n    opacity: 0;\n    pointer-events: none;\n    transform: translate(-50%, 4px);\n    transition: opacity .15s ease, transform .15s ease;\n  }\n\n  .solicitudes-page .countersColors .counter-filter:hover::after,\n  .solicitudes-page .countersColors .counter-filter:focus-visible::after {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n\n  .solicitudes-page .countersColors .counter-all { background: transparent; }\n  .solicitudes-page .countersColors .counter-pending { background: #e02b28; }\n  .solicitudes-page .countersColors .counter-progress { background: #006699; }\n  .solicitudes-page .countersColors .counter-review { background: #e0a019; }\n  .solicitudes-page .countersColors .counter-approved { background: #5de02b; }\n}\n\n@media (max-width: 1199px) {\n  body.solicitudes-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  body.solicitudes-responsive-page .sidenav---sidenav---_2tBP {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 12000;\n    width: 0;\n    min-width: 0;\n    overflow: hidden;\n    transform: translateX(-100%);\n    transition: width .2s ease, transform .2s ease;\n  }\n\n  body.solicitudes-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {\n    width: min(280px, 86vw);\n    min-width: min(280px, 86vw);\n    overflow-y: auto;\n    transform: translateX(0);\n    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);\n  }\n\n  .solicitudes-page .solicitudes-mobile-menu-toggle {\n    display: inline-flex;\n  }\n\n  .solicitudes-page #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 62px;\n  }\n\n  body.solicitudes-responsive-page .solicitudes-responsive-offcanvas {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    height: 100vh;\n    z-index: 13000;\n  }\n\n  body.solicitudes-responsive-page .offcanvas-backdrop {\n    z-index: 12990;\n  }\n}\n\n@media (max-width: 767px) {\n  .solicitudes-page .content-wrapper {\n    padding-bottom: 78px;\n  }\n\n  .solicitudes-page #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px 4px 58px;\n  }\n\n  .solicitudes-page #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .solicitudes-page .container-fluid.container-p-y {\n    width: 100%;\n    max-width: 100%;\n    padding: 12px 16px 86px;\n    overflow-x: hidden;\n  }\n\n  .solicitudes-page .solicitudes-toolbar {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    gap: 10px;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-heading,\n  .solicitudes-page .solicitudes-search,\n  .solicitudes-page .solicitudes-fullscreen {\n    width: auto;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-heading {\n    grid-column: 1 / -1;\n  }\n\n  .solicitudes-page .solicitudes-heading .label_trafico {\n    display: block;\n    margin: 0 !important;\n    color: #29445d;\n    font-size: 18px !important;\n  }\n\n  .solicitudes-page .solicitudes-subtitle {\n    display: block;\n    margin: -2px 0 0;\n    color: #71859a;\n    font-size: 12px;\n  }\n\n  .solicitudes-page .solicitudes-fullscreen {\n    grid-column: 2;\n    grid-row: 2;\n  }\n\n  .solicitudes-page .solicitudes-fullscreen button {\n    width: 44px;\n    height: 44px;\n    padding: 0;\n    border-radius: 10px;\n  }\n\n  .solicitudes-page .solicitudes-search {\n    grid-column: 1;\n    grid-row: 2;\n  }\n\n  .solicitudes-page .solicitudes-search .input-group,\n  .solicitudes-page .solicitudes-search input {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .solicitudes-page .solicitudes-search .input-group {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    align-items: stretch;\n    overflow: hidden;\n    border-radius: 10px;\n  }\n\n  .solicitudes-page .solicitudes-search .input-group-text {\n    display: inline-flex;\n    flex: 0 0 54px;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-search input {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .solicitudes-page .solicitudes-filters-row {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: auto;\n    margin: 18px clamp(0px, 3.2vw, 22px) 0;\n  }\n\n  .solicitudes-page .solicitudes-filters-row > * {\n    width: 100%;\n    padding: 0;\n  }\n\n  .solicitudes-page .labelRowSelect {\n    margin: 0;\n    gap: 3px;\n    padding: 10px 14px;\n    border: 1px solid #e1eaf3;\n    border-radius: 16px;\n    background: #fff;\n    box-shadow: 0 5px 16px rgba(31, 55, 80, .06);\n    height: 84px;\n    min-height: 0;\n  }\n\n  .solicitudes-page .solicitudes-city-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #6c8299;\n    font-size: 13px;\n  }\n\n  .solicitudes-page .solicitudes-city-label i {\n    color: #6d849c;\n    font-size: 19px;\n  }\n\n  .solicitudes-page .labelRowSelect .label_trafico,\n  .solicitudes-page .labelRowSelect .form-select {\n    width: 100%;\n    font-size: 14px;\n  }\n\n  .solicitudes-page .labelRowSelect .form-select {\n    height: 28px;\n    padding: 0;\n    border: 0;\n    color: #193a5c;\n    font-size: 16px;\n    font-weight: 600;\n    background-color: transparent;\n  }\n\n  .solicitudes-page .countersColors {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n    margin: 0;\n    width: 100%;\n    min-width: 0;\n    overflow: visible;\n  }\n\n  .solicitudes-page .countersColors .counter-filter {\n    position: relative;\n  }\n\n  .solicitudes-page .countersColors .counter-filter {\n    display: flex;\n    flex: 1 1 0;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    min-width: 0;\n    height: 52px;\n    padding: 5px 8px;\n    border: 1px solid transparent;\n    border-radius: 10px;\n    color: #000;\n    text-align: center;\n    line-height: 1.1;\n  }\n\n  .solicitudes-page .counter-filter span {\n    display: none;\n  }\n\n  .solicitudes-page .counter-filter strong {\n    font-size: 22px;\n  }\n\n  .solicitudes-page .counter-filter .counter-dot {\n    display: none;\n  }\n\n  .solicitudes-page .countersColors .counter-all { background: var(--solicitud-filter-all); border-color: #000; }\n  .solicitudes-page .countersColors .counter-pending { background: var(--solicitud-filter-red); border-color: #000; }\n  .solicitudes-page .countersColors .counter-progress { background: var(--solicitud-filter-blue); border-color: #000; color: #fff; }\n  .solicitudes-page .countersColors .counter-review { background: var(--solicitud-filter-yellow); border-color: #000; }\n  .solicitudes-page .countersColors .counter-approved { background: var(--solicitud-filter-green); border-color: #000; }\n\n  .solicitudes-page .buttonSolicitudes {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n    margin: 0;\n  }\n\n  .solicitudes-page .buttonSolicitudes button {\n    display: inline-flex;\n    flex: 0 0 auto;\n    width: 100%;\n    min-width: 0;\n    min-height: 48px;\n    justify-content: center;\n    padding: 9px 12px;\n    border-radius: 10px;\n    text-align: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 13px;\n  }\n\n  .solicitudes-page .buttonSolicitudes button:first-child {\n    color: #0864bd;\n    border: 1px solid #bcdcff;\n    background: #edf5ff;\n  }\n\n  .solicitudes-page .buttonSolicitudes button:last-child {\n    color: #fff;\n    background: linear-gradient(135deg, #096fc2, #0063b8);\n  }\n\n  .solicitudes-page .buttonSolicitudes button i {\n    margin-right: 7px;\n    font-size: 20px;\n  }\n\n  .solicitudes-page .controlSolicitudes {\n    display: none;\n  }\n\n  .solicitudes-page .controlSolicitudes2 {\n    display: block;\n    margin-top: 18px;\n  }\n\n  .solicitudes-page .containerCardsSolicitudes {\n    gap: 12px;\n    margin: 0;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial {\n    padding: 14px;\n    border: 1px solid #dce7f0;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 5px 16px rgba(31, 55, 80, .08);\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .header {\n    align-items: center;\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #e8eef4;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .header p {\n    margin: 0;\n    color: #29445d;\n    font-size: 16px;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .header p strong {\n    font-size: 19px;\n  }\n\n  .solicitudes-page .solicitud-status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 7px;\n    padding: 5px 10px;\n    border-radius: 999px;\n    background: #edf5ff;\n    color: #126bd4;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  .solicitudes-page .solicitud-status-badge i {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: currentColor;\n  }\n\n  .solicitudes-page .solicitud-status-pending .solicitud-status-badge,\n  .solicitudes-page .solicitud-status-expired .solicitud-status-badge { background: var(--solicitud-filter-red); color: #fff; }\n  .solicitudes-page .solicitud-status-neutral .solicitud-status-badge { background: var(--solicitud-filter-all); color: #000; border: 1px solid #000; }\n  .solicitudes-page .solicitud-status-progress .solicitud-status-badge { background: var(--solicitud-filter-blue); color: #fff; }\n  .solicitudes-page .solicitud-status-review .solicitud-status-badge { background: var(--solicitud-filter-yellow); color: #000; }\n  .solicitudes-page .solicitud-status-approved .solicitud-status-badge { background: var(--solicitud-filter-green); color: #000; }\n\n  .solicitudes-page .cardSolicitudesInitial .opcionesSolicitud {\n    gap: 6px;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .opcionesSolicitud button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    padding: 0;\n    border: 1px solid #d7e3ec;\n    border-radius: 9px;\n    background: #f7fbfe;\n    color: #006699;\n    cursor: pointer;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .opcionesSolicitud button:hover {\n    background: #eaf4fb;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .body {\n    display: grid;\n    gap: 9px;\n    padding-top: 2px;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .body p {\n    display: grid;\n    grid-template-columns: 20px 112px minmax(0, 1fr);\n    align-items: center;\n    gap: 5px;\n    margin: 0;\n    color: #516a80;\n    font-size: 13px;\n    line-height: 1.35;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .body p > i {\n    color: #6c849d;\n    font-size: 18px;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .body p > span {\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .body strong {\n    color: #243b53;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .card-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-top: 16px;\n    padding-top: 12px;\n    border-top: 1px solid #e8eef4;\n    color: #6c8299;\n    font-size: 12px;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .card-footer span {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .card-footer button {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #6c8299;\n    font: inherit;\n    cursor: pointer;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .card-footer button:hover,\n  .solicitudes-page .cardSolicitudesInitial .card-footer button:focus-visible {\n    color: #006699;\n    outline: none;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .solicitud-extra-details {\n    display: grid;\n    gap: 7px;\n    margin-top: 14px;\n    padding: 12px 0;\n    border-top: 1px solid #e8eef4;\n    border-bottom: 1px solid #e8eef4;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .solicitud-extra-details p {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    margin: 0;\n    color: #516a80;\n    font-size: 12px;\n    line-height: 1.35;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .solicitud-extra-details strong {\n    color: #243b53;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .solicitud-extra-details span {\n    min-width: 0;\n    text-align: right;\n    overflow-wrap: anywhere;\n  }\n\n  .solicitudes-page .cardSolicitudesInitial .card-footer i {\n    font-size: 17px;\n  }\n}\n\n/* Los estados también son filtros visibles: etiqueta, color y cantidad. */\n@media (min-width: 768px) {\n  .solicitudes-page .countersColors .counter-filter {\n    width: auto;\n    min-width: 42px;\n    height: 34px;\n    gap: 7px;\n    padding: 5px 9px;\n    border-radius: 8px;\n    white-space: nowrap;\n  }\n\n  .solicitudes-page .countersColors .counter-filter span {\n    display: inline;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  .solicitudes-page .countersColors .counter-filter strong {\n    font-size: 14px;\n  }\n\n  .solicitudes-page .countersColors .counter-filter .counter-dot {\n    display: inline-block;\n    width: 7px;\n    height: 7px;\n    flex: 0 0 7px;\n    border-radius: 50%;\n    background: currentColor;\n  }\n\n  .solicitudes-page .countersColors .counter-all .counter-dot {\n    border: 1px solid #6c8299;\n    background: #fff;\n  }\n}\n\n.solicitudes-page .solicitudes-status-filter {\n  min-width: 0;\n  margin-bottom: 24px;\n}\n\n.solicitudes-page .solicitudes-status-filter .solicitudes-select__control {\n  min-height: 44px;\n  background: #fff;\n}\n\n.solicitudes-page .solicitudes-status-filter .solicitudes-select__value-container {\n  gap: 4px;\n}\n\n.solicitudes-page .solicitudes-status-filter .solicitudes-select__multi-value__remove:hover {\n  border-radius: 999px;\n  background: rgba(23, 66, 99, .12);\n  color: #174263;\n}\n\n@media (max-width: 767px) {\n  .solicitudes-page .solicitudes-status-filter {\n    width: 100%;\n    margin-bottom: 0;\n  }\n}\n\n/* Distribución de la cabecera: herramientas, filtros, acciones y tabla no se superponen. */\n@media (min-width: 768px) {\n  .solicitudes-page .solicitudes-toolbar {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto minmax(320px, 0.95fr);\n    align-items: center;\n    column-gap: 18px;\n    margin: 0 0 18px;\n  }\n\n  .solicitudes-page .solicitudes-toolbar > * {\n    width: auto;\n    min-width: 0;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-heading {\n    grid-column: 1;\n  }\n\n  .solicitudes-page .solicitudes-fullscreen {\n    grid-column: 2;\n  }\n\n  .solicitudes-page .solicitudes-search {\n    grid-column: 3;\n  }\n\n  .solicitudes-page .solicitudes-filters-row {\n    display: grid;\n    grid-template-columns: minmax(280px, 1fr) minmax(280px, 1fr) minmax(330px, 1.25fr);\n    align-items: center;\n    gap: 18px;\n    margin: 0 0 14px;\n  }\n\n  .solicitudes-page .solicitudes-filters-row > * {\n    width: auto;\n    min-width: 0;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter,\n  .solicitudes-page .solicitudes-status-filter {\n    margin: 0;\n    min-width: 0;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {\n    font-size: 14px;\n  }\n\n  .solicitudes-page .solicitudes-actions-row {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin: 0 0 14px;\n  }\n\n  .solicitudes-page .solicitudes-actions-row > * {\n    width: auto;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-actions-row .buttonSolicitudes {\n    width: auto;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter > .solicitudes-select__container,\n  .solicitudes-page .solicitudes-status-filter > .solicitudes-select__container {\n    flex: 1 1 0;\n    width: 0;\n    min-width: 220px;\n  }\n\n  .solicitudes-page .solicitudes-status-filter > .solicitudes-select__container {\n    width: 100%;\n  }\n}\n\n@media (max-width: 767px) {\n  .solicitudes-page .solicitudes-actions-row {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-actions-row > * {\n    width: 100%;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-actions-row .buttonSolicitudes {\n    width: 100%;\n  }\n}\n\n/* Modo compacto para portátiles de 14\" y ventanas desktop reducidas. */\n@media (min-width: 768px) and (max-width: 2200px) {\n  .solicitudes-page .container-fluid.container-p-y {\n    padding-left: clamp(18px, 2.2vw, 32px);\n    padding-right: clamp(18px, 2.2vw, 32px);\n  }\n\n  .solicitudes-page .solicitudes-toolbar {\n    grid-template-columns: minmax(0, 1fr) auto minmax(300px, 1.15fr);\n    column-gap: 12px;\n    margin-bottom: 14px;\n  }\n\n  .solicitudes-page .solicitudes-heading .label_trafico {\n    font-size: clamp(18px, 1.6vw, 22px) !important;\n  }\n\n  .solicitudes-page .solicitudes-filters-row {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: 12px 16px;\n    margin-bottom: 12px;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter {\n    display: grid;\n    grid-template-columns: minmax(100px, auto) minmax(0, 1fr);\n    align-items: center;\n    gap: 8px;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {\n    font-size: 13px;\n  }\n\n  .solicitudes-page .solicitudes-status-filter {\n    grid-column: 1 / -1;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-actions-row {\n    margin-bottom: 12px;\n  }\n\n  .solicitudes-page .buttonSolicitudes button {\n    min-height: 42px;\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n}\n\n/* Evita que los filtros se dispersen demasiado en monitores anchos. */\n@media (min-width: 2201px) {\n  .solicitudes-page .solicitudes-toolbar,\n  .solicitudes-page .solicitudes-filters-row,\n  .solicitudes-page .solicitudes-actions-row {\n    width: min(100%, 2050px);\n  }\n\n  .solicitudes-page .solicitudes-filters-row {\n    grid-template-columns: minmax(480px, 0.95fr) minmax(480px, 0.95fr) minmax(620px, 1.25fr);\n    gap: 22px;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter {\n    gap: 14px;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {\n    font-size: 15px;\n  }\n\n  .solicitudes-page .solicitudes-select__control {\n    min-height: 48px;\n    font-size: 15px;\n  }\n}\n\n/* En monitores grandes todos los controles viven en una sola fila. */\n@media (min-width: 2201px) {\n  .solicitudes-page .solicitudes-toolbar {\n    margin-bottom: 12px;\n  }\n\n  .solicitudes-page .solicitudes-controls-row {\n    display: grid;\n    grid-template-columns: minmax(360px, 1.25fr) minmax(390px, 1fr) minmax(390px, 1fr) minmax(470px, 1.3fr) auto;\n    grid-template-areas: \"search city company status fullscreen\";\n    align-items: center;\n    gap: 18px;\n    width: min(100%, 2350px);\n    margin: 0 0 14px;\n  }\n\n  .solicitudes-page .solicitudes-controls-row > * {\n    width: auto;\n    min-width: 0;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search {\n    grid-area: search;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen {\n    grid-area: fullscreen;\n    justify-self: end;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-city-filter {\n    grid-area: city;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-company-filter {\n    grid-area: company;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {\n    grid-area: status;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter,\n  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {\n    margin: 0;\n  }\n}\n\n/* En 14\" se conserva el modo compacto, pero dentro del mismo bloque de controles. */\n@media (min-width: 768px) and (max-width: 2200px) {\n  .solicitudes-page .solicitudes-controls-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"search fullscreen\"\n      \"city company\"\n      \"status status\";\n    gap: 12px 16px;\n    width: 100%;\n    margin: 0 0 12px;\n  }\n\n  .solicitudes-page .solicitudes-controls-row > * {\n    width: auto;\n    min-width: 0;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search {\n    grid-area: search;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen {\n    grid-area: fullscreen;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-city-filter {\n    grid-area: city;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-company-filter {\n    grid-area: company;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {\n    grid-area: status;\n    margin: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .solicitudes-page .solicitudes-controls-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"search fullscreen\"\n      \"city city\"\n      \"company company\"\n      \"status status\";\n    gap: 10px;\n    width: 100%;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row > * {\n    width: auto;\n    min-width: 0;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search {\n    grid-area: search;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen {\n    grid-area: fullscreen;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-city-filter {\n    grid-area: city;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-company-filter {\n    grid-area: company;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {\n    grid-area: status;\n    margin: 0;\n  }\n}\n\n/* Search móvil alineado visualmente con los selects responsive. */\n@media (max-width: 767px) {\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search .input-group {\n    display: flex !important;\n    align-items: stretch;\n    width: 100%;\n    height: 56px;\n    min-height: 56px;\n    overflow: hidden;\n    border: 1px solid #cfddea;\n    border-radius: 16px;\n    background: #fff;\n    box-shadow: 0 4px 14px rgba(31, 55, 80, .06);\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search .input-group-text {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 56px;\n    height: 100%;\n    padding: 0;\n    border: 0;\n    border-right: 1px solid #e0e8ef;\n    background: transparent;\n    color: #58758f;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search input {\n    flex: 1 1 auto;\n    width: 100%;\n    min-width: 0;\n    height: 100%;\n    padding: 0 14px;\n    border: 0;\n    outline: 0;\n    background: transparent;\n    color: #304f6e;\n    font-size: 15px;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search input::placeholder {\n    color: #9aabbb;\n    opacity: 1;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 56px;\n    height: 56px;\n    min-width: 56px;\n    padding: 0;\n    border: 1px solid #cfddea;\n    border-radius: 16px;\n    background: #fff;\n    color: #58758f;\n    box-shadow: 0 4px 14px rgba(31, 55, 80, .06);\n  }\n}\n\n/* PC de escritorio: búsqueda, filtros y fullscreen en una sola fila. */\n@media (min-width: 1200px) {\n  .solicitudes-page .solicitudes-controls-row {\n    display: grid;\n    grid-template-columns: minmax(300px, 1.2fr) minmax(250px, 1fr) minmax(250px, 1fr) minmax(300px, 1.15fr) 54px;\n    grid-template-areas: \"search city company status fullscreen\";\n    align-items: center;\n    gap: 14px;\n    width: 100%;\n    margin: 0 0 14px;\n  }\n\n  .solicitudes-page .solicitudes-controls-row > * {\n    width: auto;\n    min-width: 0;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search {\n    grid-area: search;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-city-filter {\n    grid-area: city;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-company-filter {\n    grid-area: company;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter {\n    grid-area: status;\n    margin: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen {\n    grid-area: fullscreen;\n    justify-self: end;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter {\n    display: block;\n    margin: 0;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-actions-row {\n    justify-content: flex-end;\n  }\n}\n\n/* Sin etiquetas visibles: los selects ocupan directamente toda su columna. */\n@media (min-width: 768px) {\n  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter {\n    display: block;\n    padding: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter > .solicitudes-select__container,\n  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter > .solicitudes-select__container {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search .input-group {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n    height: 54px;\n    min-height: 54px;\n    overflow: hidden;\n    border: 1px solid #cfdce8;\n    border-radius: 10px;\n    background: #fff;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search .input-group-text {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 54px;\n    height: 100%;\n    padding: 0;\n    border: 0;\n    border-right: 1px solid #d9e3ec;\n    background: #fff;\n    color: #58758f;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search input {\n    width: 100%;\n    min-width: 0;\n    height: 100%;\n    padding: 0 14px;\n    border: 0;\n    outline: 0;\n    background: transparent;\n    color: #304f6e;\n    font-size: 15px;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-search input:focus {\n    box-shadow: none;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-multi-filter .solicitudes-select__control,\n  .solicitudes-page .solicitudes-controls-row .solicitudes-status-filter .solicitudes-select__control {\n    min-height: 54px;\n    height: 54px;\n    border-radius: 10px;\n  }\n}\n\n/* Controles de solicitudes: misma escala visual para filtros, acciones y listas. */\n.solicitudes-page .solicitudes-filters-row,\n.solicitudes-page .solicitudes-actions-row {\n  width: 100%;\n}\n\n.solicitudes-page .solicitudes-select__container {\n  width: 100%;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 54px;\n    height: 54px;\n    min-width: 54px;\n    padding: 0;\n    border: 1px solid #cfdce8;\n    border-radius: 10px;\n    background: #fff;\n    color: #58758f;\n    box-shadow: none;\n    font-size: 18px;\n  }\n\n  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen button:hover,\n  .solicitudes-page .solicitudes-controls-row .solicitudes-fullscreen button:focus-visible {\n    border-color: #5d8fba;\n    background: #f4f9fc;\n    color: #305274;\n    outline: none;\n  }\n}\n\n.solicitudes-page .solicitudes-select__control {\n  min-height: 54px !important;\n  width: 100%;\n  border-radius: 12px;\n}\n\n.solicitudes-page .solicitudes-select__value-container {\n  min-height: 52px;\n  padding: 7px 14px;\n}\n\n.solicitudes-page .solicitudes-select__placeholder,\n.solicitudes-page .solicitudes-select__single-value {\n  font-size: 16px;\n}\n\n.solicitudes-page .solicitudes-select__indicators {\n  min-height: 52px;\n}\n\n.solicitudes-page .solicitudes-select__indicator {\n  padding: 10px;\n}\n\n.solicitudes-page .solicitudes-status-filter {\n  width: 100%;\n}\n\n.solicitudes-page .buttonSolicitudes button {\n  min-height: 54px;\n  border-radius: 12px;\n}\n\n@media (min-width: 768px) {\n  .solicitudes-page .solicitudes-filters-row {\n    align-items: stretch;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter {\n    min-height: 54px;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-select__container {\n    flex: 1 1 0;\n  }\n\n  .solicitudes-page .solicitudes-status-filter {\n    margin-bottom: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .solicitudes-page .solicitudes-filters-row {\n    gap: 14px;\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .solicitudes-page .solicitudes-multi-filter,\n  .solicitudes-page .solicitudes-status-filter {\n    box-sizing: border-box;\n    min-height: 112px;\n    padding: 14px;\n    border: 1px solid #d4e1ee;\n    border-radius: 16px;\n    background: #fff;\n    box-shadow: 0 5px 16px rgba(31, 55, 80, .06);\n  }\n\n  .solicitudes-page .solicitudes-multi-filter .solicitudes-city-label {\n    margin-bottom: 10px;\n    font-size: 15px;\n  }\n\n  .solicitudes-page .solicitudes-select__control {\n    min-height: 58px !important;\n    border-radius: 12px;\n  }\n\n  .solicitudes-page .solicitudes-select__value-container,\n  .solicitudes-page .solicitudes-select__indicators {\n    min-height: 56px;\n  }\n\n  .solicitudes-page .solicitudes-select__placeholder,\n  .solicitudes-page .solicitudes-select__single-value {\n    font-size: 17px;\n  }\n\n  .solicitudes-page .solicitudes-actions-row {\n    margin-top: 14px;\n  }\n\n  .solicitudes-page .buttonSolicitudes button {\n    min-height: 56px;\n    padding: 12px 14px;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
